<template>
  <div>
    <!--    Breadcrumbs-->
    <breadcrumb style="margin-left: -15px">
      <breadcrumb-item>
        <a href="/customers/all?count=10&page=1">Customers</a>
      </breadcrumb-item>
      <breadcrumb-item>
        <span>{{ customer.first_name }} {{ customer.last_name }}</span>
      </breadcrumb-item>
    </breadcrumb>
    <!--    Loader-->
    <loading-panel :loading="loading"></loading-panel>

    <div class="row">
      <div class="col-lg-3 col-12">
        <card class="card-user">
          <p class="card-text"></p>
          <div class="author mt-5">
            <div class="block block-one"></div>
            <div class="block block-two"></div>
            <div class="block block-three"></div>
            <div class="block block-four"></div>
            <a href="javascript:void(0)">
              <img v-if="customer.img != null" class="avatar" :src="customer.img" alt="..." />
              <img v-if="customer.img == null" class="avatar" src="https://console.offthecouch.io/img/placeholder.jpg" alt="..." />
              <h4 class="title">{{customer.first_name}} {{customer.last_name}}</h4>
            </a>
          </div>
          <p></p>
          <div class="card-description text-center mx-3 mb-4">
            <p>
              <i v-if="customer.email != null" class="tim-icons icon-email-85"></i>
              {{ customer.email }}
            </p>
            <p>
              <i v-if="customer.phone != null && customer.phone != ''" class="tim-icons el-icon-mobile-phone"></i>
              {{ formatPhone(customer.phone) }}
            </p>
            <p>
              <i v-if="customer.address_line_1 != '' || customer.address_line_2 != ''" class="tim-icons el-icon-location"></i>
              {{ customer.address_line_1 }} <span v-if="customer.address_line_1 != '' && customer.address_line_2 != ''">,</span>
              {{ customer.address_line_2 }}
            </p>
            <p>{{customer.city}} {{customer.state}} {{customer.zip}} {{getCountry()}}</p>
            <p v-if="customer.birthday && !customer.birthday.includes('0000')" class="text-warning">
              <i class="tim-icons icon-gift-2"></i> {{getFormattedDate(customer.birthday)}}
            </p>
          </div>
          <div class="tags-row justify-content-center mb-3">
            <span
              v-for="t in tags"
              :key="'TT' + t.id"
              class="tag-chip text-white"
              :class="{ 'tag-chip--archived': t.is_archived }"
              :style="tagChipStyle(t.color)"
            >
              {{ t.name }}
            </span>
          </div>
          <div class="row mb-3">
            <div class="col">
              <base-checkbox disabled v-model="company_customer.opted_out_email">
                <span class="text-white">Opted out of email communication</span></base-checkbox>
              <base-checkbox disabled v-model="company_customer.opted_out_photo_sharing">
                <span class="text-white">Opted out of photo sharing on social media</span>
              </base-checkbox>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col">
              <label>Date joined</label>
              <p>{{ getLocalDate(company_customer.date_joined) }}</p>
            </div>
            <div class="col">
              <label>Date last visited</label>
              <p>{{ getLocalDate(company_customer.date_last_visited) }}</p>
            </div>
          </div>
        </card>
      </div>
      <div class="col-lg-9" :key="j + 'O'">
        <card style="min-height: 150px; word-break: break-word">
          <div class="row mb-3">
            <div class="col">
              <!-- Tab rail (handles mobile itself via short labels) with the
                   archive menu on the same line -->
              <div class="d-flex align-items-end customer-tabs-header">
                <tab-rail
                  :tabs="categories"
                  :value="activeTabIndex"
                  @input="switchTab"
                  class="flex-grow-1"
                ></tab-rail>
                <div v-if="hasPermissions('customer_archive')" class="ml-3 customer-tabs-menu">
                  <el-dropdown>
                    <base-button
                      simple
                      type="primary"
                      link
                      icon
                    >
                      <i style="font-size: medium" class="tim-icons el-icon-more"></i>
                    </base-button>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <a v-if="isArchived" class="dropdown-item" @click="restoreDialog.show = true">
                          <i class="tim-icons text-default icon-refresh-02 mr-2"></i> Restore customer
                        </a>
                        <a v-else class="dropdown-item" @click="archiveDialog.show = true">
                          <i class="tim-icons text-default el-icon-delete mr-2"></i> Archive customer
                        </a>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>

          <info-hint v-if="isArchived" variant="warning" icon="icon-alert-circle-exc">
            This customer is archived, so their profile is read only.
            <span v-if="visited_again">They visited again after being archived.</span>
            <template v-if="hasPermissions('customer_archive')" #action>
              <base-button size="sm" variant="outlined" tone="primary" @click="restoreDialog.show = true">Restore customer</base-button>
            </template>
          </info-hint>

<!--          Customer details-->
          <div class="row" v-if="activeTabIndex === 0">
            <div class="col">
              <div class="row">
                <div class="col">
                  <info-hint class="mt-0">When you update customer information, it will only be visible within the scope of your company.
                    Information set by customer in their profile will remain unchanged.</info-hint>
                </div>
              </div>

              <fieldset :disabled="isArchived" class="border-0 p-0 m-0">
              <div class="row">
                <div class="col-lg-4 col-12">
                  <base-input v-model="company_customer.first_name" label="First name" placeholder="First name"></base-input>
                </div>
                <div class="col-lg-4 col-12">
                  <base-input v-model="company_customer.last_name" label="Last name" placeholder="Last name"></base-input>
                </div>
                <div class="col-lg-4 col-12">
                  <base-input label="Birthday" :error="errs.birthday">
                    <el-date-picker :editable="false" :disabled="isArchived" placeholder="Birthday"
                      v-model="company_customer.birthday" :picker-options="{ firstDayOfWeek: first_day_of_week }"
                      :format="day_of_week + '' + date_format_cal"
                    ></el-date-picker>
                  </base-input>
<!--                  <base-input :error="errs.birthday" v-mask="'##/##/####'" v-model="company_customer.birthday" label="Date of birth" :placeholder="placeholder_dob"></base-input>-->
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-12">
                  <base-input v-model="company_customer.email" label="Email" disabled placeholder="Email"></base-input>
                </div>
                <div class="col-lg-6 col-12">
                  <base-input
                    type="text"
                    label="Phone">
                    <phone-number-input ref="phoneInput"
                                        v-model="company_customer.phone" @phone-update="handlePhoneUpdate"
                                        :default-country="countryCode || 'US'"
                    />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <base-input v-model="company_customer.address_line_1" label="Address line 1" placeholder="Address line 1"></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <base-input v-model="company_customer.address_line_2" label="Address line 2" placeholder="Address line 2"></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-12">
                  <base-input v-model="company_customer.city" :label="company_customer.country.city_label" :placeholder="company_customer.country.city_label"></base-input>
                </div>
                <div class="col-lg-3 col-12">
                  <base-input v-if="company_customer.country.state_label === 'State'" :label="company_customer.country.state_label">
                    <el-select
                      v-model="company_customer.state"
                      :disabled="isArchived"
                      class="select-primary"
                      name="email_group"
                      :placeholder="company_customer.country.state_label"
                    >
                      <el-option
                        v-for="(s, i) in states"
                        class="select-primary"
                        :label="s.name"
                        :value="s.name"
                        :key="'S' + i"
                      ></el-option>
                    </el-select>
                  </base-input>
                  <base-input v-else :placeholder="company_customer.country.state_label" :label="company_customer.country.state_label"
                              v-model="company_customer.state"></base-input>
                </div>
                <div class="col-lg-2 col-12">
                  <base-input v-model="company_customer.zip" :label="company_customer.country.zip_label"
                              :placeholder="company_customer.country.zip_placeholder"></base-input>
                </div>
                <div class="col">
                  <base-input label="Country">
                    <el-select
                               v-model="company_customer.country"
                               :disabled="isArchived"
                               class="select-primary"
                               name="email_group"
                               placeholder="Country"
                               value-key="code"
                    >
                      <el-option
                        v-for="(c, i) in countries"
                        class="select-primary"
                        :label="c.name"
                        :value="{name: c.name, code: c.code, city_label: c.city_label,
                      state_label: c.state_label, zip_label: c.zip_label, zip_placeholder: c.zip_placeholder,
                      phone_placeholder: c.phone_placeholder}"
                        :key="'C' + i"
                      ></el-option>
                    </el-select>
                  </base-input>
                </div>
              </div>
              </fieldset>
              <div v-if="!isArchived" class="row mt-2">
                <div class="col">
                  <base-button v-on:click="updateCustomer()" type="primary">
                    Update customer details
                  </base-button>
                </div>
              </div>
            </div>
          </div>

<!--          Games-->
          <div v-if="activeTabIndex === 1 && games.length <= 0" class="mt-3" >
            <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <h4 class="mt-3">No games have been completed.</h4>
            </div>
          </div>
          <div class="row" v-if="activeTabIndex === 1 && games.length > 0">
            <div class="col d-block d-sm-none">
              <b-table :items="games" :fields="['game']">
                <template v-slot:cell(game)="row">
                  <div class="card-title text-primary" style="font-size: medium">{{row.item.name}}</div>
                  <div>
                    <i class="tim-icons icon-calendar-60"></i>
                    {{getDayOfWeek(row.item.booking_date)}} {{getFormattedDate(row.item.booking_date)}}
                    <i class="tim-icons ml-2 icon-time-alarm"></i>
                    {{getTime(row.item.start_time)}}
                  </div>

                  <div class="mt-2">
                    <small><span class="text-primary">Completion time:</span>  {{getCompletionTime(row.item)}}</small>
                  </div>
                  <div class="mt-1">
                    <small><span class="text-primary">Number of hints:</span>  {{row.item.number_of_hints}}</small>
                  </div>
                  <div v-if="row.item.pre_game_notes">
                    <small><span class="text-primary">Pre-game notes:</span>
                      {{truncatedText(row.item.pre_game_notes)}}
                        <a href="#" style="font-size: large" v-if="isTextLong(row.item.pre_game_notes)" v-on:click="setNotes(row.item.pre_game_notes)">...</a>

                    </small>
                  </div>
                  <div v-if="row.item.post_game_notes">
                    <small><span class="text-primary">Post-game notes:</span>
                      {{truncatedText(row.item.post_game_notes)}}
                      <a href="#" style="font-size: large" v-if="isTextLong(row.item.post_game_notes)" v-on:click="setNotes(row.item.post_game_notes)">...</a>

                    </small>
                  </div>
                  <div class="mt-3">
                    <base-button
                      @click="viewDetails(row.item)"
                      simple style="width: 100%"
                      type="primary"
                      size="sm"
                    >View game history
                    </base-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="col d-none d-sm-block">
              <b-table :items="games" :fields="gameFields">
                <template v-slot:cell(game)="row">
                  <span>{{row.item.name}}</span>
                </template>
                <template v-slot:cell(booking)="row">
                  <div>{{getDayOfWeek(row.item.booking_date)}} {{getFormattedDate(row.item.booking_date)}}</div>
                   <div>{{getTime(row.item.start_time)}}</div>
                </template>
                <template v-slot:cell(completion_time)="row">
                  <span>{{getCompletionTime(row.item)}}</span>
                </template>
                <template v-slot:cell(hints)="row">
                  <span>{{row.item.number_of_hints}}</span>
                </template>
                <template v-slot:cell(notes)="row">
                  <span v-if="!row.item.pre_game_notes && !row.item.post_game_notes">-</span>
                  <div v-if="row.item.pre_game_notes">
                    <label>Pre-game</label>
                    <p>{{truncatedText(row.item.pre_game_notes)}}
                      <a href="#" style="font-size: large" v-if="isTextLong(row.item.pre_game_notes)" v-on:click="setNotes(row.item.pre_game_notes)">...</a>
                    </p>
                  </div>
                  <div v-if="row.item.post_game_notes">
                    <label>Post-game</label>
                    <p v-on:>{{truncatedText(row.item.post_game_notes)}}
                    <a href="#" style="font-size: large" v-if="isTextLong(row.item.post_game_notes)" v-on:click="setNotes(row.item.post_game_notes)">...</a>
                    </p>
                  </div>
                  <modal :show.sync="modals.notes"
                         body-classes="p-0"
                         modal-classes="modal-dialog-centered">
                    <card type="secondary"
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-4 py-lg-4s"
                          class="border-0 mb-0">

                      <p class="mt-3 text-white">{{selectedNote}}</p>
                      <div class="row mt-3 justify-content-center">
                        <div class="col text-center">
                          <base-button v-on:click="modals.notes = false" type="primary">Ok</base-button>
                        </div>
                      </div>
                    </card>
                  </modal>
                </template>
                <template v-slot:cell(actions)="row">
                  <el-dropdown>
                    <base-button
                      simple
                      type="primary"
                      link
                    > <i style="font-size: medium" class="tim-icons el-icon-more"></i>
                    </base-button>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <a class="dropdown-item" target="_blank" :href="'/games/history/instance?id=' + row.item.id">
                          <i class="tim-icons text-success icon-puzzle-10 mr-2"></i> View game details
                        </a>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </template>
              </b-table>
            </div>
          </div>

<!--          Transactions-->
          <div v-if="activeTabIndex === 2 && !loading" class="row mb-3">
            <div class="col">
              <label class="d-flex align-items-center mb-0" style="cursor: pointer">
                <el-switch
                  v-model="showAllGroupTransactions"
                  active-color="#e14eca"
                ></el-switch>
                <span class="ml-2 text-white" style="font-size: 14px">Show all locations</span>
              </label>
            </div>
          </div>
          <div v-if="activeTabIndex === 2 && transactions.length <= 0 && !loading" class="mt-3" >
            <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <h4 class="mt-3">No transactions have been made.</h4>
            </div>
          </div>
          <div class="row" v-if="activeTabIndex === 2 && transactions.length > 0">
            <div class="col d-block d-sm-none">
              <b-table :items="transactions" :fields="['transaction']">
                <template v-slot:cell(transaction)="row">
                  <div class="row">
                    <div class="col">
                      <p style="font-size: medium" class="text-white">Order #{{row.item.order_number}}
                        <el-tooltip
                          content="View transaction details"
                          effect="light"
                          :open-delay="300"
                          placement="right"
                        >
                          <i style="cursor: pointer" v-on:click="viewTransactionDetails(row.item)" class="tim-icons el-icon-top-right text-primary"></i>
                        </el-tooltip>
                      </p>
                    </div>
                    <div class="col-3 text-right">
                      <badge type="success" v-if="row.item.status === 1">active</badge>
                      <badge type="danger" v-if="row.item.status === 0">cancelled</badge>
                      <badge type="warning" v-if="row.item.status === 2">pending</badge>
                      <badge type="danger" v-if="row.item.status === 3">failed</badge>
                    </div>
                  </div>
                  <small style="font-style: italic">Purchased by {{row.item.first_name}} {{row.item.last_name}}
                    on {{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}</small>
                  <div v-if="showAllGroupTransactions && row.item.company_group_name" class="mt-1">
                    <small><i class="tim-icons el-icon-location mr-1"></i>{{ row.item.company_group_name }}</small>
                  </div>

                  <div v-if="row.item.bookings" v-for="(b, i) in JSON.parse(row.item.bookings)" :key="'BB' + i">
                    <p class="text-white mt-2">{{b.game_name}}</p>
                    <small style="font-style: italic"><i class="tim-icons icon-calendar-60 mr-1"></i>{{getDayOfWeek(b.booking_date)}} {{getFormattedDate(b.booking_date)}}
                      <i class="tim-icons icon-time-alarm mr-1 ml-1"></i> {{getTime(b.start_time)}}</small>
                  </div>
                  <small v-if="row.item.custom_field_count > 0">
                    {{row.item.custom_field_count}} responses from the booking site
                    <el-tooltip
                      content="View customer responses"
                      effect="light"
                      :open-delay="300"
                      placement="right"
                    >
                      <i style="cursor: pointer" v-on:click="viewCustomFields(row.item)" class="tim-icons el-icon-top-right text-primary"></i>
                    </el-tooltip>
                  </small>
                </template>
              </b-table>
            </div>
            <div class="col d-none d-sm-block">
              <b-table :items="transactions" :fields="transactionTableFields">
                <template v-slot:cell(location)="row">
                  <span>{{ row.item.company_group_name }}</span>
                </template>
                <template v-slot:cell(bookings)="row">
                  <div v-if="row.item.bookings" v-for="(b, i) in JSON.parse(row.item.bookings)" :key="'BB' + i">
                    <p class="text-white mt-2">{{b.game_name}}</p>
                    <small style="font-style: italic"><i class="tim-icons icon-calendar-60 mr-1"></i>{{getDayOfWeek(b.booking_date)}} {{getFormattedDate(b.booking_date)}}
                      <i class="tim-icons icon-time-alarm mr-1 ml-1"></i> {{getTime(b.start_time)}}</small>
                  </div>
                  <div v-if="!row.item.bookings">-</div>
                </template>
                <template v-slot:cell(status)="row">
                  <badge type="success" v-if="row.item.status === 1">active</badge>
                  <badge type="danger" v-if="row.item.status === 0">cancelled</badge>
                  <badge type="warning" v-if="row.item.status === 2">pending</badge>
                  <badge type="danger" v-if="row.item.status === 3">failed</badge>
                </template>
                <template v-slot:cell(additional_information)="row">
                  <small v-if="row.item.custom_field_count > 0">
                    {{row.item.custom_field_count}} responses from the booking site
                    <el-tooltip
                      content="View customer responses"
                      effect="light"
                      :open-delay="300"
                      placement="right"
                    >
                      <i style="cursor: pointer" v-on:click="viewCustomFields(row.item)" class="tim-icons el-icon-top-right text-primary"></i>
                    </el-tooltip>
                  </small>
                  <small v-else>-</small>
                </template>
                <template v-slot:cell(transaction_details)="row">
                  <p style="font-size: medium" class="text-white">Order #{{row.item.order_number}}
                    <el-tooltip
                      content="View transaction details"
                      effect="light"
                      :open-delay="300"
                      placement="right"
                    >
                      <i style="cursor: pointer" v-on:click="viewTransactionDetails(row.item)" class="tim-icons el-icon-top-right text-primary"></i>
                    </el-tooltip>
                  </p>
                  <small style="font-style: italic">Purchased by {{row.item.first_name}} {{row.item.last_name}}
                    on {{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}</small>
                </template>
              </b-table>
            </div>
          </div>
          <modal :show.sync="modals.custom_fields"
                 body-classes="p-0"
                 modal-classes="modal-dialog-centered modal-lg">
            <card type="secondary"
                  header-classes="bg-white pb-5"
                  body-classes="px-lg-5 py-lg-5"
                  class="border-0 mb-0">

              <h4>Customer responses</h4>
              <div class="row">
                <div class="col">
                  <b-table :items="customer_responses" :fields="['custom_field', 'response', 'timestamp']">
                    <template v-slot:cell(custom_field)="row">
                      {{row.item.label}}
                      <span  v-if="row.item.type === 1">
                      <span v-if="row.item.external_links" v-for="(el, i) in JSON.parse(row.item.external_links)" :key="'ELI' + i">
                        <a target="_blank" :href="el.link">{{el.link_text}}</a>
                      </span>
                      <span v-if="row.item.policies" v-for="(p, i) in JSON.parse(row.item.policies)" :key="'PLI' + i">
                        <base-button style="color: #ba54f5; font-weight:300; font-size: small; padding: 0"
                                     size="sm" link class="btn btn-link" href="" v-on:click="openPolicy(p)">{{p.policy_link_text}}</base-button>
                      </span>
                      <modal :show.sync="modals.policy"
                             body-classes="p-0"
                             modal-classes="modal-dialog-centered">
                        <card type="secondary"
                              header-classes="bg-white pb-5"
                              body-classes="px-lg-4 py-lg-4s"
                              class="border-0 mb-0">

                            <p class="text-white" v-html="selectedPolicy"></p>
                            <div class="row mt-3 justify-content-center">
                              <div class="col text-center">
                                <base-button v-on:click="modals.policy = false" type="primary">I agree</base-button>
                              </div>
                            </div>
                          </card>
                        </modal>
                      </span>
                    </template>
                    <template v-slot:cell(response)="row">
                      <span v-if="row.item.type === 1 && !row.item.response">No</span>
                      <span v-if="row.item.type === 1 && row.item.response">Yes</span>
                      <span v-if="row.item.type !== 1">{{row.item.response}}</span>
                    </template>
                    <template v-slot:cell(timestamp)="row">
                      {{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row text-center mt-3">
                <div class="col">
                  <base-button type="secondary" @click="modals.custom_fields = false">Ok</base-button>
                </div>
              </div>
            </card>
          </modal>

<!--          Payments & credit tab - simplified sections-->
          <!-- Section 1: Saved Payment Methods (Only show if Stripe) -->
          <div v-if="activeTabIndex === 3 && payment_gateway === 3">
            <div class="card card-plain mb-3">
              <div class="card-header">
                <h4 class="card-title mb-0">
                  <i class="tim-icons icon-credit-card mr-2"></i>
                  Saved payment methods
                </h4>
              </div>
              <div class="card-body">
                <div class="row mb-3" v-if="stripe_store_credit_card && !isArchived">
                  <div class="col">
                    <base-button size="sm" type="primary" @click="openAddCardModal()">
                      <i class="tim-icons icon-simple-add mr-1"></i> Add stored credit card
                    </base-button>
                  </div>
                </div>

                <!-- Loading state -->
                <div v-if="loading_payment_methods" class="text-center py-3">
                  <i class="fas fa-spinner fa-spin"></i> Loading payment methods...
                </div>

                <!-- No payment methods -->
                <div v-else-if="payment_methods.length === 0" class="text-muted">
                  <p>No saved payment methods yet.</p>
                </div>

                <!-- Payment methods list -->
                <div v-else>
                  <!-- Desktop view -->
                  <div class="d-none d-sm-block">
                    <div v-for="card in payment_methods" :key="card.id"
                         class="card mb-2" style="background: rgba(255,255,255,0.05);">
                      <div class="card-body py-3">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <i :class="getCardBrandIcon(card.card_brand)" class="text-white" style="font-size: 2rem;"></i>
                          </div>
                          <div class="col">
                            <div class="d-flex align-items-center">
                              <strong class="text-white">{{ getCardBrandName(card.card_brand) }}</strong>
                              <badge v-if="card.is_default" type="primary" class="ml-2">Default</badge>
                            </div>
                            <span class="text-white">•••• •••• •••• {{ card.card_last_four }}</span>
                            <span class="text-white opacity-8 ml-3">Expires {{ card.card_exp_month }}/{{ card.card_exp_year }}</span>
                            <div v-if="card.cardholder_name" class="text-white opacity-8">
                              {{ card.cardholder_name }}
                            </div>
                          </div>
                          <div class="col-auto">
                            <el-dropdown v-if="!isArchived">
                              <base-button link type="primary" size="sm">
                                <i style="font-size: large" class="tim-icons el-icon-more"></i>
                              </base-button>
                              <template #dropdown>
                                <el-dropdown-menu>
                                  <a v-if="!card.is_default" class="dropdown-item" @click="setDefaultPaymentMethod(card)" href="#">
                                    <i class="tim-icons text-info icon-check-2 mr-2"></i> Set as default
                                  </a>
                                  <hr v-if="!card.is_default">
                                  <a class="dropdown-item" @click="deletePaymentMethod(card)" href="#">
                                    <i class="tim-icons text-danger icon-trash-simple mr-2"></i> Remove card
                                  </a>
                                </el-dropdown-menu>
                              </template>
                            </el-dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Mobile view -->
                  <div class="d-block d-sm-none">
                    <div v-for="card in payment_methods" :key="'m-' + card.id"
                         class="card mb-2" style="background: rgba(255,255,255,0.05);">
                      <div class="card-body py-3">
                        <div class="d-flex align-items-center mb-2">
                          <i :class="getCardBrandIcon(card.card_brand)" class="text-white mr-2" style="font-size: 1.5rem;"></i>
                          <strong class="text-white">{{ getCardBrandName(card.card_brand) }}</strong>
                          <badge v-if="card.is_default" type="primary" class="ml-2">Default</badge>
                        </div>
                        <div class="text-white mb-1">•••• {{ card.card_last_four }}</div>
                        <div class="text-white opacity-8">Expires {{ card.card_exp_month }}/{{ card.card_exp_year }}</div>
                        <div class="d-flex justify-content-end mt-2">
                          <el-dropdown v-if="!isArchived">
                            <base-button link type="primary" size="sm">
                              <i style="font-size: large" class="tim-icons el-icon-more"></i>
                            </base-button>
                            <template #dropdown>
                              <el-dropdown-menu>
                                <a v-if="!card.is_default" class="dropdown-item" @click="setDefaultPaymentMethod(card)" href="#">
                                  <i class="tim-icons text-info icon-check-2 mr-2"></i> Set as default
                                </a>
                                <hr v-if="!card.is_default">
                                <a class="dropdown-item" @click="deletePaymentMethod(card)" href="#">
                                  <i class="tim-icons text-danger icon-trash-simple mr-2"></i> Remove card
                                </a>
                              </el-dropdown-menu>
                            </template>
                          </el-dropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Stripe customer info (for debugging/admin) -->
                <div v-if="stripe_customer" class="mt-3 text-white opacity-5" style="font-size: 0.8rem;">
                  <small>Stripe customer ID: {{ stripe_customer.stripe_customer_id }}</small>
                </div>
              </div>
            </div>

            <hr style="border-color: #ffffff;">
          </div>

          <!-- Section 1b: Saved Payment Methods (Only show if Square) -->
          <div v-if="activeTabIndex === 3 && payment_gateway === 2">
            <div class="card card-plain mb-3">
              <div class="card-header">
                <h4 class="card-title mb-0">
                  <i class="tim-icons icon-credit-card mr-2"></i>
                  Saved payment methods
                </h4>
              </div>
              <div class="card-body">
                <div class="row mb-3" v-if="square_store_credit_card && !isArchived">
                  <div class="col">
                    <base-button size="sm" type="primary" @click="openAddSquareCardModal()">
                      <i class="tim-icons icon-simple-add mr-1"></i> Add stored credit card
                    </base-button>
                  </div>
                </div>

                <!-- Loading state -->
                <div v-if="loading_square_payment_methods" class="text-center py-3">
                  <i class="fas fa-spinner fa-spin"></i> Loading payment methods...
                </div>

                <!-- No payment methods -->
                <div v-else-if="square_payment_methods.length === 0" class="text-muted">
                  <p>No saved payment methods yet.</p>
                </div>

                <!-- Payment methods list -->
                <div v-else>
                  <!-- Desktop view -->
                  <div class="d-none d-sm-block">
                    <div v-for="card in square_payment_methods" :key="'sq-' + card.id"
                         class="card mb-2" style="background: rgba(255,255,255,0.05);">
                      <div class="card-body py-3">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <i :class="getCardBrandIcon(card.card_brand)" class="text-white" style="font-size: 2rem;"></i>
                          </div>
                          <div class="col">
                            <div class="d-flex align-items-center">
                              <strong class="text-white">{{ getCardBrandName(card.card_brand) }}</strong>
                              <badge v-if="card.is_default" type="primary" class="ml-2">Default</badge>
                            </div>
                            <span class="text-white">•••• •••• •••• {{ card.card_last_four }}</span>
                            <span class="text-white opacity-8 ml-3">Expires {{ card.card_exp_month }}/{{ card.card_exp_year }}</span>
                            <div v-if="card.cardholder_name" class="text-white opacity-8">
                              {{ card.cardholder_name }}
                            </div>
                          </div>
                          <div class="col-auto">
                            <el-dropdown v-if="!isArchived">
                              <base-button link type="primary" size="sm">
                                <i style="font-size: large" class="tim-icons el-icon-more"></i>
                              </base-button>
                              <template #dropdown>
                                <el-dropdown-menu>
                                  <a v-if="!card.is_default" class="dropdown-item" @click="setDefaultSquarePaymentMethod(card)" href="#">
                                    <i class="tim-icons text-info icon-check-2 mr-2"></i> Set as default
                                  </a>
                                  <hr v-if="!card.is_default">
                                  <a class="dropdown-item" @click="deleteSquarePaymentMethod(card)" href="#">
                                    <i class="tim-icons text-danger icon-trash-simple mr-2"></i> Remove card
                                  </a>
                                </el-dropdown-menu>
                              </template>
                            </el-dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Mobile view -->
                  <div class="d-block d-sm-none">
                    <div v-for="card in square_payment_methods" :key="'sq-m-' + card.id"
                         class="card mb-2" style="background: rgba(255,255,255,0.05);">
                      <div class="card-body py-3">
                        <div class="d-flex align-items-center mb-2">
                          <i :class="getCardBrandIcon(card.card_brand)" class="text-white mr-2" style="font-size: 1.5rem;"></i>
                          <strong class="text-white">{{ getCardBrandName(card.card_brand) }}</strong>
                          <badge v-if="card.is_default" type="primary" class="ml-2">Default</badge>
                        </div>
                        <div class="text-white mb-1">•••• {{ card.card_last_four }}</div>
                        <div class="text-white opacity-8">Expires {{ card.card_exp_month }}/{{ card.card_exp_year }}</div>
                        <div class="d-flex justify-content-end mt-2">
                          <el-dropdown v-if="!isArchived">
                            <base-button link type="primary" size="sm">
                              <i style="font-size: large" class="tim-icons el-icon-more"></i>
                            </base-button>
                            <template #dropdown>
                              <el-dropdown-menu>
                                <a v-if="!card.is_default" class="dropdown-item" @click="setDefaultSquarePaymentMethod(card)" href="#">
                                  <i class="tim-icons text-info icon-check-2 mr-2"></i> Set as default
                                </a>
                                <hr v-if="!card.is_default">
                                <a class="dropdown-item" @click="deleteSquarePaymentMethod(card)" href="#">
                                  <i class="tim-icons text-danger icon-trash-simple mr-2"></i> Remove card
                                </a>
                              </el-dropdown-menu>
                            </template>
                          </el-dropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Square customer info (for debugging/admin) -->
                <div v-if="square_customer" class="mt-3 text-white opacity-5" style="font-size: 0.8rem;">
                  <small>Square customer ID: {{ square_customer.square_customer_id }}</small>
                </div>
              </div>
            </div>

            <hr style="border-color: #ffffff;">
          </div>

<!--          Section 2: Customer credit-->
          <div v-if="activeTabIndex === 3">
            <div class="card card-plain mb-3">
              <div class="card-header">
                <h4 class="card-title mb-0">
                  <i class="tim-icons icon-wallet-43 mr-2"></i>
                  Customer credit
                </h4>
              </div>
              <div class="card-body">
                <!-- If no credits, just show add button -->
                <div v-if="customer_credits.length === 0">
                  <div class="row">
                    <div class="col">
                      <base-button v-if="!isArchived" size="sm" type="primary" v-on:click="newCustomerCredit()">
                        <i class="tim-icons el-icon-plus mr-1"></i> Add customer credit</base-button>
                    </div>
                  </div>
                </div>

                <!-- If credits exist, show everything -->
                <div v-else>
                  <div class="row mb-2">
                    <div class="col">
                      <base-button v-if="!isArchived" size="sm" type="primary" v-on:click="newCustomerCredit()">
                        <i class="tim-icons el-icon-plus mr-1"></i> Add customer credit</base-button>
                    </div>
                  </div>

                  <div class="row">
            <div class="col d-block d-sm-none">
              <b-table :items="customer_credits" :fields="['customer_credit']">
                <template v-slot:cell(customer_credit)="row">
                  <h4 class="card-title">{{getCurrencySymbol()}}{{getNumberFormat(row.item.total.toFixed(2))}} {{getCurrencyCode()}}</h4>
                  <small>{{row.item.description}}</small>
                  <div class="mt-2">Spent: {{getCurrencySymbol()}}{{getNumberFormat(row.item.spent.toFixed(2))}} {{getCurrencyCode()}}</div>
                  <div class="mt-2">Remaining: {{getCurrencySymbol()}}{{getNumberFormat(row.item.remaining.toFixed(2))}} {{getCurrencyCode()}}</div>
                  <div class="mt-2">
                    <span>Created by {{row.item.first_name}} {{row.item.last_name}}</span><br/>
                    <small v-if="row.item.timestamp" class="font-italic">{{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}</small>
                  </div>
                  <div class="mt-2">
                    <base-button
                      v-if="!isArchived"
                      @click="editCustomerCredit(row.item)"
                      simple
                      type="warning"
                      size="sm"
                      style="width: 100%"
                    > <i class="tim-icons mr-2 icon-pencil"> </i> Edit
                    </base-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="col d-none d-sm-block">
              <b-table :items="customer_credits" :fields="customerCreditFields">
                <template v-slot:cell(credits)="row">
                  <h4 class="card-title">{{getAmount(row.item.total)}}</h4>
                  <small>{{row.item.description}}</small>
                </template>
                <template v-slot:cell(spent)="row">
                  <h4>{{getAmount(row.item.spent)}}
                  </h4>
<!--                  <el-tooltip-->
<!--                    content="View "-->
<!--                    effect="light"-->
<!--                    :open-delay="300"-->
<!--                    placement="right"-->
<!--                  >-->
<!--                    <i class="tim-icons el-icon-top-right text-primary"></i>-->
<!--                  </el-tooltip>-->
                </template>
                <template v-slot:cell(remaining)="row">
                  <h4>{{getAmount(row.item.remaining)}}</h4>
                </template>
                <template v-slot:cell(created_by)="row">
                  <span>{{row.item.first_name}} {{row.item.last_name}}</span><br/>
                  <small v-if="row.item.timestamp" class="font-italic">{{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}</small>
                </template>
                <template v-slot:cell(actions)="row">
                  <el-tooltip content="Delete customer credit" v-if="row.item.spent === 0 && !isArchived"
                              effect="light"
                              :open-delay="300"
                              placement="top">
                    <base-button
                      @click="deleteCustomerCredit(row.item)"
                      simple
                      type="danger"
                      link
                    > <i class="tim-icons icon-trash-simple"></i>
                    </base-button>
                  </el-tooltip>
                  <el-tooltip content="Edit customer credit"
                              effect="light"
                              :open-delay="300"
                              placement="top">
                    <base-button
                      v-if="!isArchived"
                      @click="editCustomerCredit(row.item)"
                      simple
                      type="warning"
                      link
                    > <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>
                </template>
              </b-table>
            </div>
          </div>
                <div class="row">
                  <div class="col-lg-2">
                    <hr style="border: 1px solid #e14eca">
                    <div class="row card-stats">
                      <div class="col">
                        <div class="numbers">
                          <slot>
                            <p class="card-category">Total credits</p>
                            <h2 class="card-title">{{ getTotalCredits() }}</h2>
                          </slot>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <hr style="border: 1px solid #e14eca">
                    <div class="row card-stats">
                      <div class="col">
                        <div class="numbers">
                          <slot>
                            <p class="card-category">Total spent</p>
                            <h2 class="card-title">{{ getSpentCredits() }}</h2>
                          </slot>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <hr style="border: 1px solid #e14eca">
                    <div class="row card-stats">
                      <div class="col">
                        <div class="numbers">
                          <slot>
                            <p class="card-category">Total remaining</p>
                            <h2 class="card-title">{{ getRemainingCredits() }}</h2>
                          </slot>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>

            <hr style="border-color: #ffffff;">
          </div>

<!--          Section: Passes-->
          <div v-if="activeTabIndex === 3">
            <div class="card card-plain mb-3">
              <div class="card-header">
                <h4 class="card-title mb-0">
                  <i class="tim-icons icon-tag mr-2"></i>
                  Passes
                </h4>
              </div>
              <div class="card-body">
                <div class="row mb-2">
                  <div class="col">
                    <base-button v-if="!isArchived" size="sm" type="primary" v-on:click="newCustomerPass()">
                      <i class="tim-icons el-icon-plus mr-1"></i> Grant pass</base-button>
                  </div>
                </div>

                <div v-if="customer_passes.length > 0" class="row">
                  <div class="col d-block d-sm-none">
                    <b-table :items="customer_passes" :fields="['pass']">
                      <template v-slot:cell(pass)="row">
                        <h4 class="card-title">{{row.item.name}}</h4>
                        <div class="mt-1">
                          <span :class="'text-' + passStatusColor(row.item.display_status)" style="text-transform: uppercase; font-size: 0.75rem; font-weight: 600">{{row.item.display_status}}</span>
                        </div>
                        <div class="mt-2">{{passAllowanceText(row.item)}}</div>
                        <div class="mt-2">
                          <small class="font-italic">{{getLocalDate(row.item.valid_from)}} to {{getLocalDate(row.item.valid_until)}}</small>
                        </div>
                        <div class="mt-2" v-if="['active','scheduled'].includes(row.item.display_status) && !isArchived">
                          <base-button
                            @click="revokePass(row.item)"
                            simple
                            type="danger"
                            size="sm"
                            style="width: 100%"
                          > <i class="tim-icons mr-2 icon-simple-remove"> </i> Revoke
                          </base-button>
                        </div>
                      </template>
                    </b-table>
                  </div>
                  <div class="col d-none d-sm-block">
                    <b-table :items="customer_passes" :fields="customerPassFields">
                      <template v-slot:cell(pass)="row">
                        <h4 class="card-title mb-0">{{row.item.name}}</h4>
                        <small v-if="row.item.source === 'purchase'">Purchased online</small>
                      </template>
                      <template v-slot:cell(allowance)="row">
                        <h4 class="mb-0">{{passAllowanceText(row.item)}}</h4>
                      </template>
                      <template v-slot:cell(validity)="row">
                        <span>{{getLocalDate(row.item.valid_from)}} to {{getLocalDate(row.item.valid_until)}}</span>
                      </template>
                      <template v-slot:cell(status)="row">
                        <span :class="'text-' + passStatusColor(row.item.display_status)" style="text-transform: uppercase; font-size: 0.75rem; font-weight: 600">{{row.item.display_status}}</span>
                      </template>
                      <template v-slot:cell(granted_by)="row">
                        <span v-if="row.item.granted_by_first_name">{{row.item.granted_by_first_name}} {{row.item.granted_by_last_name}}</span>
                        <span v-else>-</span><br/>
                        <small v-if="row.item.created_at" class="font-italic">{{getLocalDate(row.item.created_at)}}</small>
                      </template>
                      <template v-slot:cell(actions)="row">
                        <el-tooltip content="Revoke pass" v-if="['active','scheduled'].includes(row.item.display_status) && !isArchived"
                                    effect="light"
                                    :open-delay="300"
                                    placement="top">
                          <base-button
                            @click="revokePass(row.item)"
                            simple
                            type="danger"
                            link
                          > <i class="tim-icons icon-simple-remove"></i>
                          </base-button>
                        </el-tooltip>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>

            <hr style="border-color: #ffffff;">
          </div>

<!--          Section 3: Gift cards-->
          <div v-if="activeTabIndex === 3">
            <div class="card card-plain mb-3">
              <div class="card-header">
                <h4 class="card-title mb-0">
                  <i class="tim-icons icon-gift-2 mr-2"></i>
                  Gift cards
                </h4>
              </div>
              <div class="card-body">
                  <div class="mt-3" v-if="gift_cards.length <= 0">
              <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
                <h4 class="mt-3">No gift purchases have been made.</h4>
              </div>
            </div>

            <div class="row d-sm-block d-none" style="word-break: break-all">
              <div class="col">
                <b-table v-if="gift_cards.length > 0" striped hover :items="gift_cards"
                         :fields="['gift_card_code', 'recipient', 'value', 'purchase_date', 'delivery_date', 'expiration_date', 'actions']">
                  <template v-slot:cell(gift_card_code)="row">
                    <p class="mt-2" style="font-weight: lighter; font-size: small">{{getGiftCardCode(row.item.code)}}</p>
                    <badge v-if="row.item.is_active" type="success">active</badge>
                    <badge v-if="!row.item.is_active" type="danger">deactivated</badge>
                  </template>
                  <template v-slot:cell(recipient)="row">
                    <div class="row" v-for="(r, i) in JSON.parse(row.item.recipients)" :key="'A' + i">
                      <div class="col">
                        <p>{{r.first_name}} {{r.last_name}}
                          <el-tooltip content="View customer"
                                      effect="light"
                                      :open-delay="300"
                                      placement="top">
                          </el-tooltip>
                        </p>
                        <small>{{r.email}}</small>
                      </div>
                    </div>
                  </template>
                  <template v-slot:cell(value)="row">
                    <p>Total: {{ getAmount(row.item.total) }}</p>
                    <p>Remaining: {{ getAmount(row.item.remaining) }}</p>
                  </template>

                  <template v-slot:cell(purchase_date)="row">
                    {{getLocalDate(row.item.date_purchased)}}, {{getLocalTime(row.item.date_purchased)}}
                  </template>
                  <template v-slot:cell(delivery_date)="row">
                    {{ getDeliveryDate(row.item.delivery_date, row.item.date_purchased) }}
                  </template>
                  <template v-slot:cell(expiration_date)="row">
                    <badge v-if="!row.item.expiration_date">does not expire</badge>
                    <span v-if="row.item.expiration_date">{{ getFormattedDate(row.item.expiration_date) }}</span>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <el-dropdown>
                      <base-button
                        link
                        type="primary"
                        size="sm"
                      > <i style="font-size: large" class="tim-icons el-icon-more"></i>
                      </base-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <a v-if="!isArchived" class="dropdown-item" @click="sendGiftCardEmailPrompt(row.item)" href="#">
                            <i style="color: #42b883" class="tim-icons icon-email-85 mr-2"></i> Resend delivery email
                          </a>
                          <a class="dropdown-item" @click="viewTransaction(row.item)" href="#">
                            <i class="tim-icons text-info icon-notes mr-2"></i> View transaction
                          </a>
                          <hr v-if="!isArchived">
                          <a v-if="!isArchived" class="dropdown-item" @click="deactivateGiftCardPrompt(row.item)" href="#">
                            <i class="tim-icons text-danger icon-trash-simple mr-2"></i> Deactivate gift card
                          </a>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="row d-sm-none d-block">
              <div class="col">
                <b-table v-if="gift_cards.length > 0" striped hover :items="gift_cards"
                         :fields="['gift_cards']">
                  <template v-slot:cell(gift_cards)="row">
                    <div class="row justify-content-between">
                      <div class="col">
                        <p style="font-weight: lighter; font-size: small">{{getGiftCardCode(row.item.code)}}</p>
                      </div>
                      <div class="col text-right">
                        <badge v-if="row.item.is_active" type="success">active</badge>
                        <badge v-if="!row.item.is_active" type="danger">deactivated</badge>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <p>{{row.item.first_name}} {{row.item.last_name}}
                          <el-tooltip content="View customer"
                                      effect="light"
                                      :open-delay="300"
                                      placement="top">
                          </el-tooltip>
                        </p>

                        <small><i class="tim-icons icon-email-85 mr-1"></i>  {{row.item.email}}</small>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col">
                        <small class="text-white">
                          Purchase date: {{getLocalDate(row.item.date_purchased)}}, {{getLocalTime(row.item.date_purchased)}}
                        </small>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <small class="text-white">
                          Delivery date: {{ getDeliveryDate(row.item.delivery_date, row.item.date_purchased) }}
                        </small>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col">
                        <small class="text-white">
                          Total:  {{ getAmount(row.item.total) }}
                        </small>
                      </div>
                      <div class="col text-right">
                        <small class="text-white">
                          Remaining: {{ getAmount(row.item.remaining) }}
                        </small>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col">
                        <div
                          class="btn-group btn-group-toggle mt-1 mb-2"
                          :class="'float-left'"
                          data-toggle="buttons" style="width:100%"
                        >
                          <label v-if="!isArchived" class="btn btn-sm btn-primary btn-simple" style="padding-right: 0; padding-left: 0">
                            <base-button
                              @click.native="deactivateGiftCardPrompt(row.item)"
                              class="like btn-link"
                              type="primary"
                              size="sm"
                              icon
                            ><i class="tim-icons icon-trash-simple"></i>
                            </base-button>
                          </label>
                          <label class="btn btn-sm btn-primary btn-simple" style="padding-right: 0; padding-left: 0">
                            <base-button
                              @click.native="viewTransaction(row.item)"
                              class="like btn-link"
                              type="primary"
                              size="sm"
                              icon
                            ><i class="tim-icons icon-notes"></i>
                            </base-button>
                          </label>
                          <label v-if="!isArchived" class="btn btn-sm btn-primary btn-simple" style="padding-right: 0; padding-left: 0">
                            <base-button
                              @click.native="sendGiftCardEmailPrompt(row.item)"
                              class="like btn-link"
                              type="primary"
                              size="sm"
                              icon
                            ><i class="tim-icons icon-email-85"></i>
                            </base-button>
                          </label>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
              </div>
            </div>
          </div>
<!--          Waivers-->
          <div v-if="activeTabIndex === 4">
            <segmented-toggle
              v-if="minors.length > 0"
              v-model="showMinorTable"
              variant="pills"
              size="sm"
              class="mb-3"
              :options="waiverViewOptions" />
            <data-table
              :columns="showMinorTable ? childWaiverColumns : waiverColumns"
              :rows="pagedWaiverRows"
              :page="waiverPage"
              :per-page="waiverPerPage"
              :total="waiverRows.length"
              @update:page="waiverPage = $event"
              row-key="id"
              :clickable="hasPermissions('waivers_update')"
              @row-click="openWaiverDrawer">
              <template #cell(booking_details)="{ row }">
                <span class="data-table__primary">{{ row.game_name || 'Walk-in' }}</span>
                <div v-if="row.booking_date" class="data-table__muted">
                  {{ getDayOfWeek(row.booking_date) }}{{ getFormattedDate(row.booking_date) }}, {{ getTime(row.start_time) }}
                </div>
              </template>
              <template #cell(child_name)="{ row }">
                <span>{{ row.first_name }} {{ row.last_name }}</span>
              </template>
              <template #cell(status)="{ row }">
                <badge v-if="waiverStatusBadge(row.status)" :type="waiverStatusBadge(row.status).type">{{ waiverStatusBadge(row.status).label }}</badge>
                <span v-else class="data-table__muted">-</span>
              </template>
              <template #cell(date_signed)="{ row }">
                <span>{{ getLocalDate(row.created_time) }}, {{ getLocalTime(row.created_time) }}</span>
              </template>
              <template #cell(signature)="{ row }">
                <waiver-signature
                  size="cell"
                  :waiver-id="row.id"
                  :signature="row.signature"
                  :has-signature="!!row.has_signature"
                  :not-participating="Number(row.not_participating) === 1"
                />
              </template>
              <template #actions="{ row }">
                <el-tooltip content="Download PDF" effect="light" :open-delay="300" placement="top">
                  <base-button
                    icon
                    class="btn-link text-white m-0"
                    :disabled="pdfGeneratingId !== null"
                    @click="downloadWaiver(row)">
                    <i :class="pdfGeneratingId === row.id ? 'el-icon-loading' : 'tim-icons icon-cloud-download-93'"></i>
                  </base-button>
                </el-tooltip>
              </template>
              <template #empty>
                <img class="empty-state-img empty-state-img--md mb-3" src="/img/pandas/waiver.png" alt="" />
                <h4 class="mb-0 text-white">No waivers signed</h4>
              </template>
            </data-table>
            <!-- Off-screen branded PDF renderer; generate() is called from Download PDF -->
            <waiver-pdf-document ref="waiverPdf" />
            <waiver-drawer
              :show="waiverDrawer.show"
              :waiver="waiverDrawer.waiver"
              :current-customer-id="$route.query.id"
              :read-only="isArchived"
              @close="waiverDrawer.show = false"
              @changed="onWaiverChanged"
              @deleted="getCustomerDetails(true)" />
          </div>

          <div v-if="activeTabIndex === 5">
            <div v-if="surveys.length <= 0" class="mt-3" >
              <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
                <h4 class="mt-3">No surveys have been filled out.</h4>
              </div>
            </div>
            <div class="row" v-if="surveys.length > 0">
              <div class="col d-block d-sm-none">
                <b-table :items="surveys" :fields="['surveys']">
                  <template v-slot:cell(surveys)="row">
                    <p>{{row.item.name}}
                      <el-tooltip
                        content="View response details"
                        effect="light"
                        :open-delay="300"
                        placement="right"
                      >
                        <i style="cursor: pointer" v-on:click="viewSurveyResponse(row.item)" class="tim-icons el-icon-top-right text-primary"></i>
                      </el-tooltip>
                    </p>
                    <small v-if="row.item.timestamp" style="font-style: italic">Date completed {{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}</small>
                  </template>
                </b-table>
              </div>
              <div class="col d-none d-sm-block">
                <b-table :items="surveys" :fields="['survey', 'date_completed', 'actions']">
                  <template v-slot:cell(survey)="row">
                    <p>{{row.item.name}}</p>
                    <small> {{row.item.description}}</small>
                  </template>

                  <template v-slot:cell(date_completed)="row">
                    {{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}
                  </template>
                  <template v-slot:cell(actions)="row">
                    <el-dropdown>
                      <base-button
                        simple
                        type="primary"
                        link
                      > <i style="font-size: medium" class="tim-icons el-icon-more"></i>
                      </base-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <a class="dropdown-item mt-1 mb-2" target="_blank" v-on:click="viewSurveyResponse(row.item)" href="#">
                            <i class="tim-icons text-info icon-notes mr-2"></i> View response details
                          </a>
                          <hr v-if="!isArchived">
                          <a v-if="!isArchived" class="dropdown-item mb-2" @click="deleteSurveyResponsePrompt(row.item)" href="#">
                            <i class="tim-icons icon-trash-simple text-danger mr-2"></i> Delete survey
                          </a>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                </b-table>
              </div>
            </div>
          </div>

          <div v-if="activeTabIndex === 6">
            <div class="row mt-2">
              <div class="col-lg-8">
                <h4 class="card-title mb-2">Notes</h4>
                <div v-if="notes.length > 0">
                  <div v-for="(bn, i) in notes" :key="'BN' + i" class="customer-note">
                    <div class="customer-note__body">
                      <span class="customer-note__text text-white">{{bn.note}}</span>
                      <button
                        v-if="!isArchived"
                        class="customer-note__remove"
                        aria-label="Delete note"
                        @click="deleteNote(bn.id)"
                      >
                        <i class="tim-icons icon-simple-remove"></i>
                      </button>
                    </div>
                    <div class="customer-note__meta">
                      {{bn.first_name}} {{bn.last_name}} on {{getLocalDate(bn.timestamp)}}, {{getLocalTime(bn.timestamp)}}
                    </div>
                  </div>
                </div>
                <p v-else-if="!new_note_field" class="customer-note__empty">No notes yet</p>
                <div v-if="new_note_field" class="mt-3">
                  <label class="customer-note-input-label">Add a note</label>
                  <textarea
                    v-model="note"
                    class="customer-note-textarea"
                    rows="3"
                    placeholder="Type your note here..."
                  ></textarea>
                  <div class="mt-2 text-right">
                    <base-button class="mr-2" size="sm" type="secondary" v-on:click="newNoteField(0)">Cancel</base-button>
                    <base-button size="sm" type="primary" :disabled="!note.trim()" v-on:click="saveNote()">Save</base-button>
                  </div>
                </div>
                <div v-else-if="!isArchived" class="mt-2">
                  <base-button size="sm" type="primary" v-on:click="newNoteField(1)"><i class="tim-icons el-icon-plus mr-1"></i> Add note</base-button>
                </div>
              </div>
            </div>
            <div class="row mt-4 mb-2">
              <div class="col-lg-8">
                <div class="d-flex align-items-baseline mb-3" style="gap: 12px;">
                  <h4 class="card-title mb-0">Tags</h4>
                  <a href="/settings/custom-fields?tab=tags" target="_blank" class="text-primary small">
                    Manage tags <i class="tim-icons el-icon-top-right" style="font-size: 10px;"></i>
                  </a>
                </div>
                <div class="tags-row">
                  <span
                    v-for="t in tags"
                    :key="'T' + t.id"
                    class="tag-chip text-white"
                    :class="{ 'tag-chip--archived': t.is_archived }"
                    :style="tagChipStyle(t.color)"
                    :title="t.is_archived ? 'Archived tag' : ''"
                  >
                    {{ t.name }}
                    <button
                      v-if="!isArchived"
                      class="tag-chip__remove"
                      :disabled="saving_tag"
                      :aria-label="'Remove tag ' + t.name"
                      @click="deleteTag(t.id)"
                    >
                      <i class="tim-icons icon-simple-remove"></i>
                    </button>
                  </span>
                  <el-select
                    v-if="adding_tag"
                    ref="tagSelect"
                    v-model="new_tag"
                    class="select-primary tag-add-select"
                    size="small"
                    filterable
                    allow-create
                    default-first-option
                    automatic-dropdown
                    popper-class="otc-select-popper tag-add-popper"
                    placeholder="Search or create a tag"
                    no-data-text="Type a name and press enter"
                    no-match-text="Press enter to create"
                    style="width: 220px"
                    @change="onTagPicked"
                    @blur="onTagSelectBlur"
                    @keyup.esc.native="adding_tag = false"
                  >
                    <el-option
                      v-for="tag in availableLibraryTags"
                      :key="'LT' + tag.id"
                      :label="tag.name"
                      :value="tag.id"
                    >
                      <span class="tag-chip__dot mr-1" :style="{ backgroundColor: tag.color }"></span>
                      {{ tag.name }}
                    </el-option>
                  </el-select>
                  <span
                    v-else-if="!isArchived"
                    class="tag-chip tag-chip--add"
                    role="button"
                    tabindex="0"
                    @click="startAddTag"
                    @keyup.enter="startAddTag"
                  >
                    <i v-if="saving_tag" class="el-icon-loading mr-1" style="color: #e14eca;"></i>
                    <i v-else class="tim-icons icon-simple-add mr-1"></i>
                    Add tag
                  </span>
                </div>
              </div>
            </div>
          </div>
<!--Photos -->
          <div v-if="activeTabIndex === 7">
            <div class="row mt-5 mb-5" v-if="photos.length > 0">
              <div class="col text-center">
                <el-carousel v-on:change="setActivePhoto" :autoplay="false" indicator-position="outside">
                  <el-carousel-item v-for="(item, index) in photos" :key="'CS' + index">
                    <img v-if="item.overlay_url" :id="'img' + index" :src="item.overlay_url" crossorigin="anonymous"
                         style="max-height: 100%; max-width: 100%; border-radius: 0px" >
                    <img v-else :id="'img' + index" :src="item.url"  crossorigin="anonymous"
                         style="max-height: 100%; max-width: 100%; border-radius: 0px" >
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>

  <!--        Email events-->
          <div v-if="activeTabIndex === 8">
            <base-button class="text-white" style="padding-left: 0" link v-on:click="getCustomerDetails()">
              <i class="tim-icons icon-refresh-01 mr-1 text-white"></i> Refresh
            </base-button>
            <div v-if="email_events.length <= 0">
              <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
                <h4 class="mt-3">No emails associated with this customer.</h4>
              </div>
            </div>
            <!--          Mobile-->
            <div v-if="email_events.length > 0" class="d-sm-none d-block">
              <b-table :items="email_events" :fields="['email_event']">
                <template v-slot:cell(email_event)="row">
                  <div class="row">
                    <div class="col">
                      <p style="font-weight: bold; font-size: medium">{{capitalizeFirstLetter(row.item.email_type)}}</p>
                    </div>
                    <div class="col text-right">
                      <badge v-if="row.item.event_type==='Open' || row.item.event_type==='Click' || row.item.event_type==='Subscription'" type="success">{{row.item.event_type}}</badge>
                      <badge v-if="row.item.event_type==='Bounce' || row.item.event_type==='Complaint' || row.item.event_type==='Reject'
                      || row.item.event_type==='Rendering Failure' || row.item.event_type==='DeliveryDelay'"
                             type="danger">{{row.item.event_type}}</badge>
                      <badge v-if="row.item.event_type==='Delivery' || row.item.event_type==='Send'" type="default">{{row.item.event_type}}</badge>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <small style="font-style: italic">{{getLocalDate(row.item.timestamp)}}, {{ getLocalTime(row.item.timestamp)}}</small>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      Recipient: {{row.item.customer_first_name}} {{row.item.customer_last_name}}
                    </div>
                  </div>
                  <div class="row" v-if="row.item.sender_email">
                    <div class="col">
                      Sender: {{row.item.sender_first_name}} {{row.item.sender_last_name}}
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div v-if="email_events.length > 0" class="d-sm-block d-none">
              <b-table :items="email_events" :fields="['email_type', 'email_status', 'time_of_event', 'recipient', 'sender']">
                <template v-slot:cell(email_type)="row">
                  {{capitalizeFirstLetter(row.item.email_type)}}
                </template>
                <template v-slot:cell(email_status)="row">
                  <badge v-if="row.item.event_type==='Open' || row.item.event_type==='Click' || row.item.event_type==='Subscription'" type="success">{{row.item.event_type}}</badge>
                  <badge v-if="row.item.event_type==='Bounce' || row.item.event_type==='Complaint' || row.item.event_type==='Reject'
                      || row.item.event_type==='Rendering Failure' || row.item.event_type==='DeliveryDelay'"
                         type="danger">{{row.item.event_type}}</badge>
                  <badge v-if="row.item.event_type==='Delivery' || row.item.event_type==='Send'" type="default">{{row.item.event_type}}</badge>
                </template>
                <template v-slot:cell(time_of_event)="row">

                  {{getLocalDate(row.item.timestamp)}}, {{ getLocalTime(row.item.timestamp)}}
                </template>
                <template v-slot:cell(recipient)="row">
                  <div>{{row.item.customer_first_name}} {{row.item.customer_last_name}}</div>
                  <small> <i class="tim-icons icon-email-85 ml-1"></i> {{row.item.customer_email}}</small>
                </template>
                <template v-slot:cell(sender)="row">
                  <div v-if="row.item.sender_email">
                    <div>{{row.item.sender_first_name}} {{row.item.sender_last_name}}</div>
                    <small><i class="tim-icons icon-email-85 ml-1"></i>  {{row.item.sender_email}}</small>
                  </div>
                  <div v-else>System</div>
                </template>
              </b-table>
            </div>

          </div>
        </card>
      </div>
    </div>


    <modal :show.sync="modals.customer_credit"
           body-classes="p-0"
           modal-classes="modal-dialog-centered modal-lg">
      <card type="secondary"
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0 mb-0">

        <h4>Add customer credit</h4>
        <div class="row mt-2">
          <div class="col-lg-3 col-12">
            <base-input label="Amount ($)" placeholder="0.00" v-model="customer_credit.amount" type="number"></base-input>
          </div>
          <div class="col">
            <base-input label="Description" placeholder="Description" v-model="customer_credit.description" ></base-input>
          </div>
        </div>

        <div class="row d-none d-sm-block text-center mt-3">
          <base-button type="secondary" @click="modals.customer_credit = false">Cancel</base-button>
          <base-button class="ml-3" type="primary" @click="addCredit()">Save</base-button>
        </div>
        <div class="row d-block d-sm-none text-center mt-3">
          <base-button simple size="sm" type="secondary" @click="modals.customer_credit = false">Cancel</base-button>
          <base-button simple size="sm" class="ml-3" type="primary" @click="addCredit()">Save</base-button>
        </div>
      </card>
    </modal>

    <modal :show.sync="modals.edit_customer_credit"
           body-classes="p-0"
           modal-classes="modal-dialog-centered modal-lg">
      <card type="secondary"
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0 mb-0">

        <h4>Edit customer credit</h4>
        <div class="row mt-2">
          <div class="col-lg-3 col-12">
            <base-input label="Amount ($)" placeholder="0.00" v-model="customer_credit.amount" type="number" :error="errs.credit_amount"></base-input>
          </div>
          <div class="col">
            <base-input label="Description" placeholder="Description" v-model="customer_credit.description" ></base-input>
          </div>
        </div>

        <div class="row d-none d-sm-block text-center mt-3">
          <base-button type="secondary" @click="modals.edit_customer_credit = false">Cancel</base-button>
          <base-button class="ml-3" type="primary" @click="editCredit()">Save</base-button>
        </div>
        <div class="row d-block d-sm-none text-center mt-3">
          <base-button simple size="sm" type="secondary" @click="modals.edit_customer_credit = false">Cancel</base-button>
          <base-button simple size="sm" class="ml-3" type="primary" @click="editCredit()">Save</base-button>
        </div>
      </card>
    </modal>

    <modal :show.sync="modals.customer_pass"
           body-classes="p-0"
           modal-classes="modal-dialog-centered modal-lg">
      <card type="secondary"
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0 mb-0">

        <h4>Grant pass</h4>
        <div class="row mt-2">
          <div class="col-lg-6 col-12">
            <base-input label="Pass type">
              <el-select v-model="customer_pass.pass_type_id" placeholder="Select a pass type" filterable>
                <el-option
                  v-for="pt in pass_type_options"
                  :key="pt.id"
                  :label="pt.name"
                  :value="pt.id"
                />
              </el-select>
            </base-input>
          </div>
          <div class="col-lg-6 col-12">
            <base-input label="Start date (optional)">
              <el-date-picker
                :editable="false"
                placeholder="Starts now"
                type="date"
                v-model="customer_pass.valid_from"
                value-format="yyyy-MM-dd"
                :format="date_format_cal"
              ></el-date-picker>
            </base-input>
          </div>
        </div>
        <div class="row" v-if="selectedPassTypeSummary">
          <div class="col">
            <small class="font-italic">{{ selectedPassTypeSummary }}</small>
          </div>
        </div>

        <div class="row d-none d-sm-block text-center mt-3">
          <base-button type="secondary" @click="modals.customer_pass = false">Cancel</base-button>
          <base-button class="ml-3" type="primary" :disabled="granting_pass" @click="grantPass()">Save</base-button>
        </div>
        <div class="row d-block d-sm-none text-center mt-3">
          <base-button simple size="sm" type="secondary" @click="modals.customer_pass = false">Cancel</base-button>
          <base-button simple size="sm" class="ml-3" type="primary" :disabled="granting_pass" @click="grantPass()">Save</base-button>
        </div>
      </card>
    </modal>

    <modal :show.sync="modals.add_card"
           body-classes="p-0"
           modal-classes="modal-dialog-centered modal-lg">
      <card type="secondary"
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0 mb-0">

        <h4>Add payment method</h4>

        <div class="row mt-3">
          <div class="col">
            <base-input label="Cardholder name">
              <input type="text" class="form-control" v-model="card_form.cardholder_name" placeholder="Name on card">
            </base-input>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <label for="card-element">Credit or debit card</label>
            <div id="card-element" class="form-control" style="height: 40px; padding-top: 10px;">
              <!-- Stripe card element will be mounted here -->
            </div>
            <div id="card-errors" role="alert" class="text-danger mt-2"></div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <el-switch active-color="#e14eca" v-model="card_form.set_as_default" />
            <label class="text-white opacity-7"> &nbsp; Set as default payment method</label>
          </div>
        </div>

        <div class="row d-none d-sm-block text-center mt-3">
          <base-button type="secondary" @click="closeAddCardModal()">Cancel</base-button>
          <base-button class="ml-3" type="primary" @click="saveCard()" :disabled="saving_card">
            <span v-if="!saving_card">Save card</span>
            <span v-else><i class="fas fa-spinner fa-spin"></i> Processing...</span>
          </base-button>
        </div>
        <div class="row d-block d-sm-none text-center mt-3">
          <base-button simple size="sm" type="secondary" @click="closeAddCardModal()">Cancel</base-button>
          <base-button simple size="sm" class="ml-3" type="primary" @click="saveCard()" :disabled="saving_card">
            <span v-if="!saving_card">Save card</span>
            <span v-else><i class="fas fa-spinner fa-spin"></i> Processing...</span>
          </base-button>
        </div>
      </card>
    </modal>

    <modal :show.sync="modals.add_square_card"
           body-classes="p-0"
           modal-classes="modal-dialog-centered modal-lg">
      <card type="secondary"
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0 mb-0">

        <h4>Add payment method</h4>

        <div class="row mt-3">
          <div class="col">
            <base-input label="Cardholder name">
              <input type="text" class="form-control" v-model="square_card_form.cardholder_name" placeholder="Name on card">
            </base-input>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <label>Credit or debit card</label>
            <div id="square-card-container" style="min-height: 50px;">
              <!-- Square card element will be mounted here -->
            </div>
            <div id="square-card-errors" role="alert" class="text-danger mt-2"></div>
          </div>
        </div>

        <div class="row d-none d-sm-block text-center mt-4">
          <base-button type="secondary" @click="closeAddSquareCardModal()">Cancel</base-button>
          <base-button class="ml-3" type="primary" @click="saveSquareCard()" :disabled="saving_square_card">
            <span v-if="!saving_square_card">Save card</span>
            <span v-else><i class="fas fa-spinner fa-spin"></i> Processing...</span>
          </base-button>
        </div>
        <div class="row d-block d-sm-none text-center mt-4">
          <base-button simple size="sm" type="secondary" @click="closeAddSquareCardModal()">Cancel</base-button>
          <base-button simple size="sm" class="ml-3" type="primary" @click="saveSquareCard()" :disabled="saving_square_card">
            <span v-if="!saving_square_card">Save card</span>
            <span v-else><i class="fas fa-spinner fa-spin"></i> Processing...</span>
          </base-button>
        </div>
      </card>
    </modal>

    <base-alert-dialog
      :show="archiveDialog.show"
      title="Archive customer"
      variant="danger"
      message="This customer will be hidden from your customer list. You can restore them from the Archived filter on the customer list."
      show-cancel
      confirm-text="Archive"
      confirm-variant="danger"
      :loading="archiveDialog.loading"
      :dismissible="!archiveDialog.loading"
      @confirm="archiveCustomer"
      @cancel="archiveDialog.show = false" />
    <base-alert-dialog
      :show="restoreDialog.show"
      title="Restore customer"
      variant="primary"
      message="This customer will return to your customer list."
      show-cancel
      confirm-text="Restore"
      :loading="restoreDialog.loading"
      :dismissible="!restoreDialog.loading"
      @confirm="restoreCustomer"
      @cancel="restoreDialog.show = false" />
    <base-alert-dialog
      :show="confirmDialog.show"
      :title="confirmDialog.title"
      :message="confirmDialog.message"
      :variant="confirmDialog.variant"
      show-cancel
      :confirm-text="confirmDialog.confirmText"
      :cancel-text="confirmDialog.cancelText"
      :confirm-variant="confirmDialog.confirmVariant"
      @confirm="answerConfirmation(true)"
      @cancel="answerConfirmation(false)" />
  </div>
</template>
<script>
  import { Auth } from 'aws-amplify'
  import {Modal} from 'src/components'
  import { BTable } from 'bootstrap-vue'
  import { API_LOCATION } from '../../api-config'
  import { tagChipStyle } from '@/util/tagChip'
  import TabRail from '@/components/TabRail.vue'
  import {time, formattedDate, dayOfWeek} from "@/plugins/dateFormatter";
  import {formatGroupDate, formatGroupTime} from "@/plugins/dates";
import {collapseEmailEvents} from "@/util/emailEvents";
  import Badge from "@/components/Badge";
  import { fetchWaiverDetail } from '@/util/waiverSignature';
  import currencies from "@/assets/currencies.json";
  import _ from "lodash";
  import countries from "@/assets/countries.json";
  import states from "@/assets/states.json";
  import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
  import BreadcrumbItem from "@/components/Breadcrumb/BreadcrumbItem";
  import {Carousel, CarouselItem, Dropdown, DropdownMenu, Select, Option} from "element-ui";
  import PhoneNumberInput from '@/components/PhoneNumberInput.vue';
  import { formatPhoneDisplay } from '@/util/phoneFormatter';
  import WaiverDrawer from '@/components/Waivers/WaiverDrawer.vue';

  const axios = require('axios')
  export default {
    name: "PlayerInfo",
    components: {
      WaiverDrawer,
      BreadcrumbItem,
      Breadcrumb,
      // VueHtml2pdf removed: waiver PDF now rendered by the shared WaiverPdfDocument (globally registered)
      BTable,
      Modal,
      Badge,
      [Dropdown.name]: Dropdown,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      TabRail,
      [CarouselItem.name]: CarouselItem,
      [Carousel.name]: Carousel,
      PhoneNumberInput
    },
    data() {
      return {
        countryCode: JSON.parse(localStorage.getItem('company')).country,
        gift_cards: [],
        surveys: [],
        showMinorTable: false,
        selectedPolicy: '',
        custom_fields: [],
        loading: false,
        adding_tag: false,
        saving_tag: false,
        library_tags: [],
        library_tags_loaded: false,
        new_note_field: false,
        notes: [],
        note: '',
        date_format: JSON.parse(localStorage.getItem('group')).date_format,
        number_format: JSON.parse(localStorage.getItem('group')).number_format,
        time_format: JSON.parse(localStorage.getItem('group')).time_format,
        currency: JSON.parse(localStorage.getItem('group')).currency,
        currency_format: JSON.parse(localStorage.getItem('group')).currency_format,
        first_day_of_week: JSON.parse(localStorage.getItem('group')).first_day_of_week,
        currency_symbol: '$',
        date_format_cal: '',
        day_of_week: '',
        currencies: currencies.currencies,
        countries: countries.countries,
        states: states.states,
        placeholder_dob: 'MM/DD/YYYY',
        new_tag: '',
        tags: [],
        customer: '',
        visited_again: false,
        confirmDialog: { show: false, title: '', message: '', variant: 'warning', confirmText: 'Confirm', cancelText: 'Cancel', confirmVariant: 'primary', resolve: null },
        archiveDialog: { show: false, loading: false },
        restoreDialog: { show: false, loading: false },
        company_customer: {
          first_name: '',
          last_name: '',
          birthday: '',
          address_line_1: '',
          address_line_2: '',
          city: '',
          state: '',
          zip: '',
          email: '',
          phone: '',
          phoneE164: '',
          country: {
            name: 'United States',
            code: 'US',
            city_label: 'City',
            state_label: 'State',
            zip_label: 'Zip',
            zip_placeholder: '95133',
            phone_placeholder: '(212) 555-1234'
          }
        },
        photos: '',
        waivers: '',
        transactions: [],
        showAllGroupTransactions: false,
        games: [],
        gameFields: ['game', 'booking', 'completion_time', 'hints', 'notes', 'actions'],
        waiverColumns: [
          { key: 'booking_details', label: 'Booking details' },
          { key: 'status', label: 'Status' },
          { key: 'date_signed', label: 'Date signed' },
          { key: 'signature', label: 'Signature' },
        ],
        childWaiverColumns: [
          { key: 'booking_details', label: 'Booking details' },
          { key: 'child_name', label: 'Child name' },
          { key: 'status', label: 'Status' },
          { key: 'date_signed', label: 'Date signed' },
          { key: 'signature', label: 'Signature' },
        ],
        waiverViewOptions: [
          { value: false, label: 'Customer waivers' },
          { value: true, label: 'Child waivers' },
        ],
        waiverDrawer: { show: false, waiver: null },
        // Client-side pages: each row's signature preview fetches its own waiver.
        waiverPage: 1,
        waiverPerPage: 10,
        customerCreditFields: ['credits', 'spent', 'remaining', 'created_by', 'actions'],
        customerPassFields: ['pass', 'allowance', 'validity', 'status', 'granted_by', 'actions'],
        customer_passes: [],
        pass_type_options: [],
        customer_pass: {
          pass_type_id: null,
          valid_from: null
        },
        granting_pass: false,
        minors: [],
        pdfGeneratingId: null,
        customer_credits: [],
        customer_credit: {
          amount: 0.00,
          description: ''
        },
        activeTabIndex: 0,
        payment_gateway: null,
        j: 0,
        modals: {
          customer_credit: false,
          edit_customer_credit: false,
          customer_pass: false,
          policy: false,
          custom_fields: false,
          notes: false,
          add_card: false,
          add_square_card: false
        },
        card_form: {
          cardholder_name: '',
          set_as_default: true
        },
        stripe: null,
        cardElement: null,
        saving_card: false,
        payment_methods: [],
        stripe_customer: null,
        loading_payment_methods: false,
        stripe_publishable_key: null,
        stripe_account_id: null,
        stripe_store_credit_card: false,
        square_customer: null,
        square_payment_methods: [],
        loading_square_payment_methods: false,
        square_store_credit_card: false,
        square: null,
        squareCardElement: null,
        square_card_form: {
          cardholder_name: ''
        },
        saving_square_card: false,
        squareAppId: '',
        squareLocationId: '',
        paymentGatewayIsLive: true,
        customer_responses: [],
        email_events: [],
        selectedNote: '',
        errs: {
          birthday: '',
          credit_amount: ''
        }
      };
    },
    computed: {
      waiverRows(){
        return (this.showMinorTable ? this.minors : this.waivers) || []
      },
      pagedWaiverRows(){
        const start = (this.waiverPage - 1) * this.waiverPerPage
        return this.waiverRows.slice(start, start + this.waiverPerPage)
      },
      availableLibraryTags(){
        const applied = new Set(this.tags.map(t => t.tag_id))
        return this.library_tags.filter(t => !applied.has(t.id))
      },
      selectedPassTypeSummary() {
        const pt = this.pass_type_options.find(p => p.id === this.customer_pass.pass_type_id)
        if (!pt) return ''
        const duration = pt.duration_value + ' ' + pt.duration_unit + (pt.duration_value === 1 ? '' : 's')
        const allowance = pt.allowance_type === 'per_booking'
          ? pt.ticket_allowance + ' ticket' + (pt.ticket_allowance === 1 ? '' : 's') + ' included per booking'
          : pt.ticket_allowance + ' ticket' + (pt.ticket_allowance === 1 ? '' : 's') + ' total'
        const games = pt.applies_to_all_games === 1 ? 'all games' : ((pt.games || []).length + ' games')
        return 'Valid ' + duration + ' from the start date, ' + allowance + ', ' + games
      },
      // Archived customers open read only until restored (OTC-2940)
      isArchived() {
        return Number(this.company_customer && this.company_customer.is_archived) === 1
      },
      categories() {
        return [
          { name: 'General', shortName: 'Info' },
          { name: 'Events', shortName: 'Events' },
          { name: 'Transactions', shortName: 'Txns' },
          { name: 'Payments & credit', shortName: 'Pay' },
          { name: 'Waivers', shortName: 'Waivers' },
          { name: 'Surveys', shortName: 'Surveys' },
          { name: 'Notes/tags', shortName: 'Notes' },
          { name: 'Photos', shortName: 'Photos' },
          { name: 'Emails', shortName: 'Emails' },
        ];
      },
      transactionTableFields() {
        const baseFields = ['transaction_details', 'status', 'bookings', 'additional_information'];
        if (this.showAllGroupTransactions) {
          return ['transaction_details', 'status', 'location', 'bookings', 'additional_information'];
        }
        return baseFields;
      }
    },
    watch: {
      showMinorTable(){
        this.waiverPage = 1
      },
      // A delete or move can empty the last page; step back to the new last page.
      waiverRows(rows){
        const lastPage = Math.max(1, Math.ceil(rows.length / this.waiverPerPage))
        if (this.waiverPage > lastPage) this.waiverPage = lastPage
      },
      showAllGroupTransactions() {
        this.getCustomerDetails()
      },
      '$route.query.tab'(newTab) {
        if (newTab !== undefined) {
          this.switchTab(Number(newTab));
        }
      }
    },
    methods: {
      tagChipStyle,
      formatPhone(phone) {
        return formatPhoneDisplay(phone, this.company_customer.country || 'US');
      },
      hasPermissions(scope){
        let permissions = JSON.parse(localStorage.getItem('permissions'))
        const matchFound = permissions.some(element => element === scope);
        return matchFound
      },
      handlePhoneUpdate(phoneData) {
        this.company_customer.phoneE164 = phoneData.e164;
      },
      setNotes(note){
        this.selectedNote = note
        this.modals.notes = true
      },
      isTextLong(fulltext){
        return fulltext.length > 25
      },
      truncatedText(fulltext) {
        return fulltext.length > 25
          ? fulltext.slice(0, 25)
          : fulltext;
      },
      getCompletionTime(game){
        let start = ''
        let end = ''
        let time = ''
        if(game.game_end_time.includes('0000')){
          if(game.game_end_time_by_puzzle){
            start = new Date(game.game_start_time)
            end = new Date(game.game_end_time_by_puzzle)
            time = (end - start) / (1000 * 60)

            if(time === 1) {
              time = time + ' minute'
            } else {
              time = time + ' minutes'
            }
            return  time + ' minutes'

          } else {
            return '-'
          }
        } else {
          start = new Date(game.game_start_time)
          end = new Date(game.game_end_time)
          time = (end - start) / (1000 * 60)
          return time + ' minutes'
        }
        return '-'
      },
      capitalizeFirstLetter(string){
        if (!string) {
          return string;
        }
        string = string.replace(/_/g, ' ');
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      viewTransaction(item){
        this.$router.push({ path: '/purchases/transactions/details', query: { id: item.transaction_id }})
      },
      async sendGiftCardEmail(item){
        this.loading = true
        let token = await this.getAuthToken()
        let config = {headers: {Authorization: token}}
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/transactions/' + item.transaction_id + '/gift-cards'
        let data = {
          email: JSON.parse(item.recipients)[0].email,
          gift_card_id: item.id
        }

        this.axios.post(url, data, config)
          .then(response => {
            this.$notify({ type: 'success', message: "Gift card delivery email sent to customer" })
            this.getCustomerDetails()
          })
          .catch(err => {
            this.loading = false
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Something went wrong' })
            }
          })
      },
      async sendGiftCardEmailPrompt(item){
        const ok = await this.askConfirmation({
          title: 'Send gift card email?',
          message: 'This sends the gift card delivery email to the recipient.',
          confirmText: 'Send email',
        })
        if (ok) this.sendGiftCardEmail(item)
      },
      async deactivateGiftCardPrompt(item){
        const ok = await this.askConfirmation({
          title: 'Deactivate gift card?',
          message: 'The gift card can no longer be used. Any remaining balance must be refunded manually.',
          variant: 'danger',
          confirmText: 'Deactivate',
          confirmVariant: 'danger',
        })
        if (ok) this.deactivateGiftCard(item)
      },
      async deactivateGiftCard(item){
        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id

        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
          '/transactions/' + item.transaction_id + '/gift-cards?id=' + item.id

        this.loading = true
        axios.delete(url, config)
          .then(response => {
            this.loading = false

            this.$notify({ type: 'success', message: "Gift card has been deactivated" })

            this.getCustomerDetails()
          })
          .catch(err => {
            this.loading = false
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Something went wrong' })
            }
          })
      },
      getDeliveryDate(delivery_date, date_purchased){
        if(!delivery_date){
          return this.getFormattedDate(date_purchased)
        } else {
          return this.getFormattedDate(delivery_date)
        }
      },
      getGiftCardCode(code){
        if(!code){
          return
        }
        if(isNaN(code)){
          return code
        }
        let c = code.match(/.{1,4}/g);
        return c.join(' ')
      },
      setActivePhoto(index){
        this.photo = this.photos[index]
      },
      async deleteSurveyResponsePrompt(item){
        const ok = await this.askConfirmation({
          title: 'Delete survey response?',
          message: 'The survey response is permanently deleted.',
          variant: 'danger',
          confirmText: 'Delete',
          confirmVariant: 'danger',
        })
        if (ok) this.deleteSurveyResponse(item)
      },
      async deleteSurveyResponse(item){
        let token = await this.getAuthToken()
        let config = {headers: {Authorization: token}}
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/surveys/history/' + item.id

        this.loading = true
        this.axios.delete(url, config)
          .then(response => {
            this.$notify({ type: 'success', message: 'Survey response has been deleted.' })
            this.getCustomerDetails()
            this.loading = false
          })
          .catch(err => {
            this.loading = false
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Something went wrong' })
            }
          })
      },
      viewSurveyResponse(item){
        this.$router.push({ path: '/surveys/history/response', query: { id:  item.id }})
      },
      viewCustomFields(item){
        this.customer_responses =  _.filter(this.custom_fields, { transaction_id: item.id })
        this.modals.custom_fields = true
      },
      openPolicy(item){
        this.selectedPolicy = item.policy
        this.modals.policy = true
      },
      getTotalCredits(){
        let total = 0
        for(let n in this.customer_credits){
          total += this.customer_credits[n].total
        }
        return this.getAmount(total)
      },
      getRemainingCredits(){
        let total = 0
        for(let n in this.customer_credits){
          total += this.customer_credits[n].remaining
        }
        return this.getAmount(total)
      },
      getSpentCredits(){
        let total = 0
        for(let n in this.customer_credits){
          total += this.customer_credits[n].spent
        }
        return this.getAmount(total)
      },
      viewTransactionDetails(item){
        this.$router.push({ path: '/purchases/transactions/details', query: { id: item.id }})
      },
      getCountry(){
        if(!this.customer.hasOwnProperty('country')){
          return ''
        } else {
          return this.customer.country.name
        }
      },
      isValidCustomerForm(){
        let errors = 0
        // if(!this.company_customer.birthday){
        //   this.errs.birthday = 'Invalid birthday'
        //   errors++
        // } else {
        //   this.errs.birthday = ''
        // }

        if(errors > 0){
          return false
        }
        return true
      },
      async updateCustomer(){
        if(!this.isValidCustomerForm()){
          return
        }

        this.loading = true
        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let customerId = this.$route.query.id
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION  + 'companies/' + companyId + '/groups/'
          + companyGroupId + '/customers/' + customerId

        let data = {
          first_name: this.company_customer.first_name,
          last_name: this.company_customer.last_name,
          email: this.company_customer.email,
          phone: this.company_customer.phoneE164 || this.company_customer.phone,
          birthday: this.company_customer.birthday ? this.company_customer.birthday.getFullYear() + '-' +  ('0' + (this.company_customer.birthday.getMonth()+1)).slice(-2) + '-' + ('0' + this.company_customer.birthday.getDate()).slice(-2) : null,
          address_line_1: this.company_customer.address_line_1,
          address_line_2: this.company_customer.address_line_2,
          city: this.company_customer.city,
          state: this.company_customer.state,
          zip: this.company_customer.zip,
          country: this.company_customer.country
        }


        axios.put(url, data, config)
          .then(response => {
            this.$notify({ type: 'success', message: 'Customer details have been updated' })
            this.loading = false
            this.getCustomerDetails()
          })
          .catch(err => {
            console.log(err)
            this.loading = false
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Something went wrong' })
            }
          })
      },
      async archiveCustomer() {
        if (await this.changeArchiveState(this.archiveDialog, 'delete', '', 'Customer archived')) {
          this.$router.push('/customers/all?count=10&page=1')
        }
      },
      async restoreCustomer() {
        if (await this.changeArchiveState(this.restoreDialog, 'put', '/restore', 'Customer restored')) {
          this.getCustomerDetails()
        }
      },
      async changeArchiveState(dialog, method, suffix, successMessage) {
        dialog.loading = true
        try {
          const token = await this.getAuthToken()
          const config = { headers: { Authorization: token } }
          const companyId = localStorage.getItem('companyId')
          const companyGroupId = JSON.parse(localStorage.getItem('group')).id
          const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${this.company_customer.id}${suffix}`
          if (method === 'put') {
            await axios.put(url, {}, config)
          } else {
            await axios.delete(url, config)
          }
          dialog.show = false
          this.$notify({ type: 'success', message: successMessage, icon: 'tim-icons icon-check-2' })
          return true
        } catch (err) {
          console.log(err)
          const message = err.response && err.response.status === 401
            ? 'You do not have access to this customer.'
            : 'Something went wrong. Please try again.'
          this.$notify({ type: 'danger', message, icon: 'tim-icons icon-alert-circle-exc' })
          return false
        } finally {
          dialog.loading = false
        }
      },
      getNumberFormat(value){
        if(this.number_format === 1){
          value = value.toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.', ',')
        }
        return value
      },
      editCustomerCredit(item){
        this.customer_credit = {
          amount: item.total.toFixed(2),
          description: item.description,
          spent: item.spent,
          id: item.id
        }
        this.errs.credit_amount = ''
        this.modals.edit_customer_credit = true
      },
      async editCredit(){
        //check that total isn't lower than spent
        if(this.customer_credit.spent > this.customer_credit.amount){
          this.errs.credit_amount = 'Amount cannot be less than the amount already spent ($' + this.customer_credit.spent + ')'
          return
        }
        this.errs.credit_amount = ''
        this.loading = true
        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let customerId = this.$route.query.id
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION  + 'companies/' + companyId + '/groups/'
          + companyGroupId + '/customers/' + customerId + '/customer-credit/' + this.customer_credit.id

        let data = this.customer_credit
        axios.put(url, data, config)
          .then(response => {
            this.$notify({ type: 'success', message: 'Customer credit has been updated' })
            this.modals.edit_customer_credit = false
            this.getCustomerDetails()
          })
          .catch(err => {
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Something went wrong' })
            }
          })
      },
      async deleteCustomerCredit(item){
        this.loading = true
        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let customerId = this.$route.query.id
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION  + 'companies/' + companyId + '/groups/'
          + companyGroupId + '/customers/' + customerId + '/customer-credit/' + item.id

        axios.delete(url, config)
          .then(response => {
            this.$notify({ type: 'success', message: 'Customer credit has been deleted' })
            this.getCustomerDetails()

          })
          .catch(err => {
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Something went wrong' })
            }
          })
      },
      async addCredit(){
        this.loading = true
        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let customerId = this.$route.query.id
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION  + 'companies/' + companyId + '/groups/'
          + companyGroupId + '/customers/' + customerId + '/customer-credit'
        let data = this.customer_credit
        axios.post(url, data, config)
          .then(response => {
            this.modals.customer_credit = false
            this.$notify({ type: 'success', message: 'Customer credit has been added' })
            this.getCustomerDetails()

          })
          .catch(err => {
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Something went wrong' })
            }
          })
      },
      newCustomerCredit(){
        this.customer_credit = {
          amount: '0.00',
          description: ''
        }
        this.modals.customer_credit = true
        this.add_customer_credit = true
      },
      async getCustomerPasses(){
        try {
          let token = await this.getAuthToken()
          let config = { headers: { Authorization: token } }
          let companyId = localStorage.getItem('companyId')
          let customerId = this.$route.query.id
          let companyGroupId = JSON.parse(localStorage.getItem('group')).id
          let url = API_LOCATION + 'companies/' + companyId + '/groups/'
            + companyGroupId + '/customers/' + customerId + '/passes'
          const response = await axios.get(url, config)
          this.customer_passes = response.data.passes || []
        } catch (err) {
          console.log(err)
        }
      },
      async newCustomerPass(){
        this.customer_pass = {
          pass_type_id: null,
          valid_from: null
        }
        this.modals.customer_pass = true
        if (this.pass_type_options.length === 0) {
          try {
            let token = await this.getAuthToken()
            let config = { headers: { Authorization: token } }
            let companyId = localStorage.getItem('companyId')
            let companyGroupId = JSON.parse(localStorage.getItem('group')).id
            let url = API_LOCATION + 'companies/' + companyId + '/groups/'
              + companyGroupId + '/pass-types'
            const response = await axios.get(url, config)
            this.pass_type_options = (response.data.pass_types || []).filter(pt => pt.is_archived === 0)
          } catch (err) {
            console.log(err)
          }
        }
      },
      passAllowanceText(item){
        const tickets = item.allowance_type === 'per_booking'
          ? item.tickets_total + ' per booking'
          : item.tickets_used + '/' + item.tickets_total + ' used'
        return tickets
      },
      passStatusColor(status){
        const colors = {
          active: 'success',
          scheduled: 'info',
          depleted: 'warning',
          expired: 'muted',
          revoked: 'danger'
        }
        return colors[status] || 'muted'
      },
      async grantPass(){
        if (!this.customer_pass.pass_type_id) {
          this.$notify({ type: 'danger', message: 'Select a pass type' })
          return
        }
        this.granting_pass = true
        try {
          let token = await this.getAuthToken()
          let config = { headers: { Authorization: token } }
          let companyId = localStorage.getItem('companyId')
          let customerId = this.$route.query.id
          let companyGroupId = JSON.parse(localStorage.getItem('group')).id
          let url = API_LOCATION + 'companies/' + companyId + '/groups/'
            + companyGroupId + '/customers/' + customerId + '/passes'
          await axios.post(url, this.customer_pass, config)
          this.modals.customer_pass = false
          this.$notify({ type: 'success', message: 'Pass has been granted' })
          this.getCustomerPasses()
        } catch (err) {
          console.log(err)
          if(err.response && err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            const data = err.response && err.response.data
            const message = data && Array.isArray(data.validation_errors) && data.validation_errors.length > 0
              ? data.validation_errors[0].message
              : (data && data.error) || 'Something went wrong'
            this.$notify({ type: 'danger', message: message })
          }
        } finally {
          this.granting_pass = false
        }
      },
      async revokePass(item){
        const ok = await this.askConfirmation({
          title: 'Revoke this pass?',
          message: 'The customer can no longer redeem it. Tickets already redeemed stay applied.',
          variant: 'danger',
          confirmText: 'Revoke',
          cancelText: 'Keep it',
          confirmVariant: 'danger',
        })
        if (!ok) return
        try {
          let token = await this.getAuthToken()
          let config = { headers: { Authorization: token } }
          let companyId = localStorage.getItem('companyId')
          let customerId = this.$route.query.id
          let companyGroupId = JSON.parse(localStorage.getItem('group')).id
          let url = API_LOCATION + 'companies/' + companyId + '/groups/'
            + companyGroupId + '/customers/' + customerId + '/passes/' + item.id
          await axios.put(url, {}, config)
          this.$notify({ type: 'success', message: 'Pass has been revoked' })
          this.getCustomerPasses()
        } catch (err) {
          console.log(err)
          this.$notify({ type: 'danger', message: 'The pass could not be revoked' })
        }
      },
      async openAddCardModal(){
        this.modals.add_card = true
        this.card_form = {
          cardholder_name: '',
          set_as_default: true
        }

        // Wait for modal to render
        await this.$nextTick()

        // Initialize Stripe if not already initialized
        if (!this.stripe) {
          if (!this.stripe_publishable_key) {
            this.$notify({ type: 'danger', message: 'Payment settings not configured. Please configure Stripe in Payment Settings.' })
            this.modals.add_card = false
            return
          }
          // A Stripe Connect venue tokenizes inside its connected account (platform key + account).
          this.stripe = Stripe(this.stripe_publishable_key, this.stripe_account_id ? { stripeAccount: this.stripe_account_id } : undefined)
        }

        // Create and mount card element
        const elements = this.stripe.elements()

        const style = {
          base: {
            fontSize: '16px',
            fontFamily: 'Poppins, sans-serif',
            color: localStorage.getItem('mode') === '0' ? '#344675' : '#ffffff'
          },
        }

        this.cardElement = elements.create('card', {style})
        this.cardElement.mount('#card-element')

        // Handle real-time validation errors
        this.cardElement.on('change', (event) => {
          const displayError = document.getElementById('card-errors')
          if (event.error) {
            displayError.textContent = event.error.message
          } else {
            displayError.textContent = ''
          }
        })
      },
      closeAddCardModal(){
        this.modals.add_card = false
        if (this.cardElement) {
          this.cardElement.destroy()
          this.cardElement = null
        }
      },
      async saveCard(){
        if (!this.card_form.cardholder_name) {
          this.$notify({ type: 'danger', message: 'Please enter the cardholder name' })
          return
        }

        this.saving_card = true

        try {
          const token = await this.getAuthToken()
          const config = { headers: { Authorization: token } }
          const companyId = localStorage.getItem('companyId')
          const customerId = this.$route.query.id
          const companyGroupId = JSON.parse(localStorage.getItem('group')).id

          // Step 1: Create SetupIntent
          const setupIntentUrl = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${customerId}/payment-methods/setup-intent`
          const setupIntentResponse = await axios.post(setupIntentUrl, { is_test: 0 }, config)

          // Step 2: Confirm card setup with Stripe
          const { setupIntent, error } = await this.stripe.confirmCardSetup(
            setupIntentResponse.data.client_secret,
            {
              payment_method: {
                card: this.cardElement,
                billing_details: {
                  name: this.card_form.cardholder_name
                }
              }
            }
          )

          if (error) {
            throw new Error(error.message)
          }

          // Step 3: Save payment method to database
          const saveUrl = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${customerId}/payment-methods`
          await axios.post(saveUrl, {
            payment_method_id: setupIntent.payment_method,
            set_as_default: this.card_form.set_as_default,
            is_test: 0
          }, config)

          this.saving_card = false
          this.closeAddCardModal()
          this.$notify({ type: 'success', message: 'Payment method added successfully' })

          // Refresh payment methods list
          await this.loadPaymentMethods()

        } catch (err) {
          this.saving_card = false
          console.error(err)
          this.$notify({ type: 'danger', message: err.message || 'Failed to save payment method' })
        }
      },
      async loadPaymentMethods() {
        if (this.payment_gateway !== 3) {
          // Only load for Stripe (gateway_id 3)
          return
        }

        this.loading_payment_methods = true
        try {
          const token = await this.getAuthToken()
          const config = { headers: { Authorization: token } }
          const companyId = localStorage.getItem('companyId')
          const customerId = this.$route.query.id
          const companyGroupId = JSON.parse(localStorage.getItem('group')).id
          const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${customerId}/stripe-customer`

          const response = await axios.get(url, config)
          this.stripe_customer = response.data.stripe_customer
          this.payment_methods = response.data.payment_methods || []
        } catch (err) {
          // 404 is expected if customer doesn't have a Stripe account yet
          if (err.response && err.response.status !== 404) {
            console.error('Failed to load payment methods:', err)
          }
          this.payment_methods = []
          this.stripe_customer = null
        } finally {
          this.loading_payment_methods = false
        }
      },
      async deletePaymentMethod(card) {
        const ok = await this.askConfirmation({
          title: 'Delete payment method?',
          message: `The card ending in ${card.card_last_four} is removed from this customer.`,
          variant: 'danger',
          confirmText: 'Delete',
          confirmVariant: 'danger',
        })
        if (!ok) return

        this.loading = true
        try {
          const token = await this.getAuthToken()
          const config = { headers: { Authorization: token } }
          const companyId = localStorage.getItem('companyId')
          const customerId = this.$route.query.id
          const companyGroupId = JSON.parse(localStorage.getItem('group')).id
          const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${customerId}/payment-methods/${card.id}`

          await axios.delete(url, config)
          this.$notify({ type: 'success', message: 'Payment method has been removed' })
          await this.loadPaymentMethods()
        } catch (err) {
          console.error(err)
          this.$notify({ type: 'danger', message: 'Failed to delete payment method' })
        } finally {
          this.loading = false
        }
      },
      async setDefaultPaymentMethod(card) {
        this.loading = true
        try {
          const token = await this.getAuthToken()
          const config = { headers: { Authorization: token } }
          const companyId = localStorage.getItem('companyId')
          const customerId = this.$route.query.id
          const companyGroupId = JSON.parse(localStorage.getItem('group')).id
          const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${customerId}/payment-methods/${card.id}`

          await axios.put(url, {}, config)
          this.$notify({ type: 'success', message: 'Default payment method updated' })
          await this.loadPaymentMethods()
        } catch (err) {
          console.error(err)
          this.$notify({ type: 'danger', message: 'Failed to update default payment method' })
        } finally {
          this.loading = false
        }
      },
      async loadSquarePaymentMethods() {
        if (this.payment_gateway !== 2) {
          // Only load for Square (gateway_id 2)
          return
        }

        this.loading_square_payment_methods = true
        try {
          const token = await this.getAuthToken()
          const config = { headers: { Authorization: token } }
          const companyId = localStorage.getItem('companyId')
          const customerId = this.$route.query.id
          const companyGroupId = JSON.parse(localStorage.getItem('group')).id
          const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${customerId}/square-customer`

          const response = await axios.get(url, config)
          this.square_customer = response.data.square_customer
          this.square_payment_methods = response.data.payment_methods || []
        } catch (err) {
          // 404 is expected if customer doesn't have a Square account yet
          if (err.response && err.response.status !== 404) {
            console.error('Failed to load Square payment methods:', err)
          }
          this.square_payment_methods = []
          this.square_customer = null
        } finally {
          this.loading_square_payment_methods = false
        }
      },
      async deleteSquarePaymentMethod(card) {
        const ok = await this.askConfirmation({
          title: 'Delete payment method?',
          message: `The card ending in ${card.card_last_four} is removed from this customer.`,
          variant: 'danger',
          confirmText: 'Delete',
          confirmVariant: 'danger',
        })
        if (!ok) return

        this.loading = true
        try {
          const token = await this.getAuthToken()
          const config = { headers: { Authorization: token } }
          const companyId = localStorage.getItem('companyId')
          const customerId = this.$route.query.id
          const companyGroupId = JSON.parse(localStorage.getItem('group')).id
          const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${customerId}/square-payment-methods/${card.id}`

          await axios.delete(url, config)
          this.$notify({ type: 'success', message: 'Payment method has been removed' })
          await this.loadSquarePaymentMethods()
        } catch (err) {
          console.error(err)
          this.$notify({ type: 'danger', message: 'Failed to delete payment method' })
        } finally {
          this.loading = false
        }
      },
      async setDefaultSquarePaymentMethod(card) {
        this.loading = true
        try {
          const token = await this.getAuthToken()
          const config = { headers: { Authorization: token } }
          const companyId = localStorage.getItem('companyId')
          const customerId = this.$route.query.id
          const companyGroupId = JSON.parse(localStorage.getItem('group')).id
          const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${customerId}/square-payment-methods/${card.id}`

          await axios.put(url, {}, config)
          this.$notify({ type: 'success', message: 'Default payment method updated' })
          await this.loadSquarePaymentMethods()
        } catch (err) {
          console.error(err)
          this.$notify({ type: 'danger', message: 'Failed to update default payment method' })
        } finally {
          this.loading = false
        }
      },
      async loadSquareJS(is_live) {
        if (window.Square) {
          return // Already loaded
        }
        return new Promise((resolve, reject) => {
          const script = document.createElement('script')
          if (is_live) {
            script.src = 'https://web.squarecdn.com/v1/square.js'
          } else {
            script.src = 'https://sandbox.web.squarecdn.com/v1/square.js'
          }
          script.async = true
          script.onload = resolve
          script.onerror = reject
          document.body.appendChild(script)
        })
      },
      async initializeSquareCard() {
        if (!window.Square) {
          throw new Error('Square.js failed to load properly')
        }

        if (this.squareCardElement) {
          this.squareCardElement.destroy()
        }

        this.square = window.Square.payments(this.squareAppId, this.squareLocationId)

        const customStyle = {
          '.input-container': {
            borderColor: '#e3e3e3',
            borderRadius: '4px'
          },
          '.input-container.is-focus': {
            borderColor: '#e14eca'
          },
          '.input-container.is-error': {
            borderColor: '#ff1600'
          },
          '.message-text': {
            color: '#adb5bd'
          },
          '.message-text.is-error': {
            color: '#ff1600'
          },
          '.message-icon': {
            color: '#adb5bd'
          },
          '.message-icon.is-error': {
            color: '#ff1600'
          },
          input: {
            backgroundColor: 'transparent',
            color: localStorage.getItem('mode') === '0' ? '#344675' : '#ffffff',
            fontSize: '16px'
          },
          'input::placeholder': {
            color: '#adb5bd'
          }
        }

        this.squareCardElement = await this.square.card({
          style: customStyle
        })

        await this.squareCardElement.attach('#square-card-container')
      },
      async openAddSquareCardModal() {
        this.modals.add_square_card = true
        this.square_card_form = {
          cardholder_name: ''
        }

        // Wait for modal to render
        await this.$nextTick()

        try {
          // Check if Square credentials are configured
          if (!this.squareAppId || !this.squareLocationId) {
            console.error('Square credentials missing:', { appId: this.squareAppId, locationId: this.squareLocationId })
            this.$notify({ type: 'danger', message: 'Square payment settings not configured. Please ensure Square credentials are set up in Payment Settings.' })
            this.modals.add_square_card = false
            return
          }

          // Load Square SDK if not already loaded
          if (!window.Square) {
            await this.loadSquareJS(this.paymentGatewayIsLive)
          }

          await this.initializeSquareCard()
        } catch (error) {
          console.error('Failed to initialize Square:', error)
          this.$notify({ type: 'danger', message: error.message || 'Failed to initialize payment form' })
          this.modals.add_square_card = false
        }
      },
      closeAddSquareCardModal() {
        this.modals.add_square_card = false
        if (this.squareCardElement) {
          this.squareCardElement.destroy()
          this.squareCardElement = null
        }
      },
      async saveSquareCard() {
        if (!this.square_card_form.cardholder_name) {
          this.$notify({ type: 'danger', message: 'Please enter the cardholder name' })
          return
        }

        this.saving_square_card = true

        try {
          // Tokenize the card
          const result = await this.squareCardElement.tokenize()

          if (result.status === 'OK') {
            const token = await this.getAuthToken()
            const config = { headers: { Authorization: token } }
            const companyId = localStorage.getItem('companyId')
            const customerId = this.$route.query.id
            const companyGroupId = JSON.parse(localStorage.getItem('group')).id

            // Save card via backend endpoint
            const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/customers/${customerId}/square-payment-methods`

            await axios.post(url, {
              source_id: result.token,
              cardholder_name: this.square_card_form.cardholder_name,
              location_id: this.squareLocationId
            }, config)

            this.saving_square_card = false
            this.closeAddSquareCardModal()
            this.$notify({ type: 'success', message: 'Payment method added successfully' })

            // Refresh payment methods list
            await this.loadSquarePaymentMethods()
          } else {
            let errorMessage = 'Failed to process card'
            if (result.errors && result.errors.length > 0) {
              errorMessage = result.errors.map(e => e.message).join(', ')
            }
            throw new Error(errorMessage)
          }
        } catch (err) {
          this.saving_square_card = false
          console.error(err)
          this.$notify({ type: 'danger', message: err.message || 'Failed to save payment method' })
        }
      },
      getCardBrandIcon(brand) {
        const brandIcons = {
          'visa': 'fab fa-cc-visa',
          'mastercard': 'fab fa-cc-mastercard',
          'amex': 'fab fa-cc-amex',
          'discover': 'fab fa-cc-discover',
          'diners': 'fab fa-cc-diners-club',
          'jcb': 'fab fa-cc-jcb'
        }
        return brandIcons[brand?.toLowerCase()] || 'tim-icons icon-credit-card'
      },
      getCardBrandName(brand) {
        const brandNames = {
          'visa': 'Visa',
          'mastercard': 'Mastercard',
          'amex': 'American Express',
          'discover': 'Discover',
          'diners': 'Diners Club',
          'jcb': 'JCB'
        }
        return brandNames[brand?.toLowerCase()] || brand || 'Card'
      },
      switchTab(index){
        this.activeTabIndex = index

        // Load payment methods when switching to Payments & credit tab
        if (index === 3) {
          this.loadPaymentMethods()
          this.loadSquarePaymentMethods()
        }
      },
      startAddTag(){
        this.adding_tag = true
        this.loadLibraryTags()
        this.$nextTick(() => {
          if (this.$refs.tagSelect) this.$refs.tagSelect.focus()
        })
      },
      async loadLibraryTags(){
        if (this.library_tags_loaded) return
        try {
          let token = await this.getAuthToken()
          let config = { headers: { Authorization: token } }
          let companyId = localStorage.getItem('companyId')
          let companyGroupId = JSON.parse(localStorage.getItem('group')).id
          let response = await axios.get(API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/tags', config)
          this.library_tags = response.data || []
          this.library_tags_loaded = true
        } catch (e) {
          console.log('Tags not available:', e.message)
        }
      },
      onTagSelectBlur(){
        // Delayed so an option click (which blurs the input first) still
        // registers its change before the field is dismissed. A save in
        // flight keeps the field open for the next add.
        setTimeout(() => {
          if (!this.saving_tag) this.adding_tag = false
        }, 200)
      },
      onTagPicked(value){
        // allow-create emits the typed string for new names, the option value
        // (tag id) for existing ones.
        this.new_tag = ''
        if (value === '' || value === null || value === undefined) return
        const name = typeof value === 'number'
          ? (this.library_tags.find(t => t.id === value) || {}).name
          : String(value).trim()
        if (!name) return
        this.saveTag(name)
      },
      newNoteField(status){
        this.new_note_field = status
      },
      // Promise form of the shared confirm dialog: resolves true on confirm, false on cancel or dismiss.
      askConfirmation({ title, message, variant = 'warning', confirmText = 'Confirm', cancelText = 'Cancel', confirmVariant = 'primary' }){
        return new Promise(resolve => {
          this.confirmDialog = { show: true, title, message, variant, confirmText, cancelText, confirmVariant, resolve }
        })
      },
      answerConfirmation(answer){
        const resolve = this.confirmDialog.resolve
        this.confirmDialog = { ...this.confirmDialog, show: false, resolve: null }
        if (resolve) resolve(answer)
      },
      openWaiverDrawer(row){
        this.waiverDrawer = { show: true, waiver: row }
      },
      onWaiverChanged(payload){
        // The customer page rows don't show participation; everything else re-fetches.
        if (payload.action === 'participation') return
        this.getCustomerDetails(true)
      },
      // Same labels and colors the waiver tables have always shown for a booking status.
      waiverStatusBadge(status){
        const map = {
          completed: { type: 'success', label: 'completed' },
          available: { type: 'default', label: 'available' },
          call_to_book: { type: 'warning', label: 'call to book' },
          blocked: { type: 'danger', label: 'blocked' },
          cancelled: { type: 'danger', label: 'cancelled' },
          removed: { type: 'danger', label: 'removed' },
          expired: { type: 'default', label: 'passed' },
          booked: { type: 'info', label: 'booked' },
        }
        return map[status] || null
      },
      async downloadWaiver(waiver){
        if (this.pdfGeneratingId !== null) return
        this.pdfGeneratingId = waiver.id
        try {
          // Fetch full detail (waiver_text + decoded signature + custom/consent fields)
          // in one round trip, then render the normalized branded PDF via the shared
          // component. Merge list-row fields (game_name/booking_date/start_time) over
          // the detail payload so the PDF header is fully populated.
          const { waiver: detail, custom_field_responses, consent_fields } =
            await fetchWaiverDetail(waiver.id, { includeSignature: true })
          await this.$refs.waiverPdf.generate({
            waiver: { ...waiver, ...detail },
            consent_fields,
            custom_field_responses,
          })
        } catch (err) {
          console.log(err)
          if (err.response && err.response.status === 401) {
            this.$notify({ type: 'danger', message: 'You do not have access to this action.' })
          } else {
            this.$notify({ type: 'danger', message: 'Could not download waiver PDF' })
          }
        } finally {
          this.pdfGeneratingId = null
        }
      },
      getLocalTime(d){
        return formatGroupTime(d)
      },
      getLocalDate(d){
        if(d && typeof d === 'string' && d.includes('0000')) return '-'
        return formatGroupDate(d)
      },
      getFormattedDate(d) {
        return formattedDate(this.date_format, d);
      },
      getTime(d) {
        return time(this.time_format, d)
      },
      getAmount(integer) {
        if (integer == null) {
          return;
        }

        // Get currency info
        const currencyInfo = _.find(this.currencies, { code: this.currency });
        const symbol = currencyInfo ? currencyInfo.symbol : this.currency_symbol;
        const isPostfix = currencyInfo ? currencyInfo.postfix : false;

        let formattedAmount;

        if (this.number_format === 1) {
          // European formatting (comma as decimal separator)
          formattedAmount = integer.toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.', ',');
        } else {
          // Standard formatting (dot as decimal separator)
          formattedAmount = parseFloat(integer).toFixed(2);
        }

        if (this.currency_format === 0) {
          // Symbol format
          if (isPostfix) {
            return formattedAmount + symbol;  // 12.34kr
          } else {
            return symbol + formattedAmount;  // $12.34
          }
        } else {
          // Currency code format
          return formattedAmount + ' ' + this.currency;  // 12.34 SEK
        }
      },
      getCurrencyCode(){
        if(this.currency_format === 1){
          return this.currency
        }
      },
      getDayOfWeek(d){
        if(!d){
          return ''
        }
        if(JSON.parse(localStorage.getItem('group')).show_day_of_week){
          return dayOfWeek(d) + ', '
        }
        return ''
      },
      getCurrencySymbol(){
        if(this.currency_format === 0){
          let c = _.find(this.currencies, { code: this.currency });
          return c.symbol
        }
      },
      getAuthToken() {
        return new Promise ( function(resolve) {
          Auth.currentSession()
            .then(data =>{
              resolve(data.idToken.jwtToken)
            })
            .catch(err => console.log(err))
        })
      },
      viewDetails(item){
        this.$router.push({ path: '/games/history/instance', query: { id: item.id }})
      },
      // silent: refresh in place without the full-page loader (after a waiver edit or delete).
      async getCustomerDetails (silent = false) {
        if (!silent) this.loading = true

        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let customerId = this.$route.query.id
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION  + 'companies/' + companyId + '/groups/' + companyGroupId + '/customers/' + customerId
        if (this.showAllGroupTransactions) {
          url += '?allGroups=true'
        }
        axios.get(url, config)
          .then(response => {
            this.customer = response.data.customer
            this.games = response.data.games
            this.photos = response.data.photos
            this.waivers = response.data.waivers
            this.transactions = response.data.transactions
            this.tags = response.data.tags
            this.notes = response.data.notes
            this.surveys = response.data.surveys
            this.customer_credits = response.data.customer_credits
            this.company_customer = response.data.customer_company_link
            this.visited_again = Boolean(response.data.visited_again)
            this.custom_fields = response.data.custom_fields
            this.minors = response.data.minors
            this.gift_cards = response.data.gift_cards
            this.email_events = collapseEmailEvents(response.data.email_events)
            this.payment_gateway = response.data.payment_gateway
            this.stripe_publishable_key = response.data.stripe_publishable_key
            this.stripe_account_id = response.data.stripe_account_id || null
            this.stripe_store_credit_card = Boolean(response.data.stripe_store_credit_card)
            this.square_store_credit_card = Boolean(response.data.square_store_credit_card)
            this.squareAppId = response.data.square_app_id
            this.squareLocationId = response.data.square_location_id
            this.paymentGatewayIsLive = Boolean(response.data.payment_gateway_is_live)

            this.company_customer.country = _.find(this.countries, { code: this.company_customer.country })
            if(!this.company_customer.country){
              this.company_customer.country = {
                name: 'United States',
                code: 'US',
                city_label: 'City',
                state_label: 'State',
                zip_label: 'Zip',
                zip_placeholder: '95133',
                phone_placeholder: '(212) 555-1234'
              }
            }
            this.customer.country = _.find(this.countries, { code: this.customer.country })
            if(!this.customer.country){
              this.customer.country = {
                name: 'United States',
                code: 'US',
                city_label: 'City',
                state_label: 'State',
                zip_label: 'Zip',
                zip_placeholder: '95133',
                phone_placeholder: '(212) 555-1234'
              }
            }
            if(!this.company_customer.birthday || this.company_customer.birthday.includes('0000')){
              this.company_customer.birthday = null
            } else {
              let birthday = new Date()
              birthday.setFullYear(response.data.customer_company_link.birthday.split('T')[0].split('-')[0])
              birthday.setMonth(response.data.customer_company_link.birthday.split('T')[0].split('-')[1] - 1, response.data.customer_company_link.birthday.split('T')[0].split('-')[2])
              this.company_customer.birthday = birthday
            }
            this.loading = false

          })
          .catch(err => {
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Something went wrong' })
            }
          })
      },
      async deleteTag(tagId){
        // Optimistic: drop the chip locally, restore on failure. No modal;
        // the tag stays in the library and is one click to re-add.
        const previous = this.tags
        this.tags = this.tags.filter(t => t.id !== tagId)
        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let customerId = this.$route.query.id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/customers/' + customerId + `/tags/` + tagId

        axios.delete(url, config)
          .catch(err => {
            console.log(err)
            this.tags = previous
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Could not update tags, please try again', timeout: 3000 })
            }
          })
      },
      async saveNote(){
        this.loading = true
        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let customerId = this.$route.query.id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/customers/' + customerId + `/notes`

        let data = {
          note: this.note
        }

        axios.post(url, data, config)
          .then(response => {
            this.loading = false
            this.note = ''
            this.new_note_field = false
            this.getCustomerDetails()
          })
          .catch(err => {
            this.loading = false
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Something went wrong' })
            }
          })
      },
      async deleteNote(id){
        this.loading = true
        let token = await this.getAuthToken()
        let config = {headers: {Authorization: token}}
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let customerId = this.$route.query.id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/customers/' + customerId + `/notes/` + id

        this.axios.delete(url, config)
          .then(response => {
            this.getCustomerDetails()
            this.loading = false
          })
          .catch(err => {
            this.loading = false
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Something went wrong' })
            }
          })
      },
      async saveTag(name){
        if (this.saving_tag) return
        this.saving_tag = true
        this.adding_tag = false
        let token = await this.getAuthToken()
        let config = { headers: { Authorization: token } }
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let customerId = this.$route.query.id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/customers/' + customerId + `/tags`

        let data = {
          name: name
        }

        axios.post(url, data, config)
          .then(response => {
            this.saving_tag = false
            // The endpoint returns the created link as JSON; append it and
            // reopen the picker so several tags can be added in a row. Fall
            // back to a full refetch if the payload is not the link object.
            const link = response.data
            if (link && typeof link === 'object' && link.id) {
              if (!this.tags.some(t => t.id === link.id)) this.tags.push(link)
              this.library_tags_loaded = false
              this.startAddTag()
            } else {
              this.getCustomerDetails()
            }
          })
          .catch(err => {
            this.saving_tag = false
            console.log(err)
            if(err.response.status == 401){
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Could not update tags, please try again', timeout: 3000 })
            }
          })
      },
    },
    beforeMount() {
      this.currency_symbol =  _.find(this.currencies, { code: JSON.parse(localStorage.getItem('group')).currency }).symbol
      this.date_format_cal = this.date_format
      this.date_format_cal =  this.date_format_cal.replaceAll('Y', 'y')
      this.date_format_cal = this.date_format_cal.replaceAll('D', 'd')
      if(JSON.parse(localStorage.getItem('group')).show_day_of_week){
        this.day_of_week = 'ddd, '
      }

      this.getCustomerDetails()
      this.getCustomerPasses()
    },
    mounted() {
      // Load Stripe.js dynamically if not already loaded
      if (!window.Stripe) {
        const script = document.createElement('script')
        script.src = 'https://js.stripe.com/v3/'
        script.async = true
        document.head.appendChild(script)
      }
      if (this.$route.query.tab !== undefined) {
        this.switchTab(Number(this.$route.query.tab));
      }
    }
  };
</script>
<style>
/* Notes/tags tab: note cards */
.customer-note {
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.03);
  padding: 10px 12px;
  margin-bottom: 8px;
}

.customer-note__body {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.customer-note__text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 0.85rem;
}

.customer-note__remove {
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: rgba(125, 125, 125, 0.9);
  line-height: 1;
  flex-shrink: 0;
}

.customer-note__remove i {
  font-size: 11px;
}

.customer-note__remove:hover {
  color: #f5365c;
}

.customer-note__remove:focus-visible {
  outline: 2px solid rgba(225, 78, 202, 0.7);
  outline-offset: 1px;
  border-radius: 3px;
}

.customer-note__meta {
  margin-top: 6px;
  font-size: 0.7rem;
  color: rgba(255, 255, 255, 0.55);
}

.customer-note__empty {
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.85rem;
}

.white-content .customer-note {
  border-color: rgba(0, 0, 0, 0.08);
  background: rgba(0, 0, 0, 0.03);
}

.white-content .customer-note__meta,
.white-content .customer-note__empty {
  color: rgba(0, 0, 0, 0.55);
}

/* Tabs header: the wrapper owns the full-width hairline so it runs under the
   archive menu too; the rail's own border is suppressed (the active-tab
   underline still overlaps via its -1px margin). Same treatment as the
   custom fields and tags page. */
.customer-tabs-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.customer-tabs-header .tab-rail {
  border-bottom-color: transparent;
  /* Flex items default to min-width auto and refuse to shrink below their
     content; without this the rail overflows the card instead of squeezing. */
  min-width: 0;
}

.customer-tabs-menu {
  margin-bottom: 6px;
}

.white-content .customer-tabs-header {
  border-bottom-color: rgba(0, 0, 0, 0.12);
}

/* Note entry: mirrors the booking drawer notes view (NotesView.vue) */
.customer-note-input-label {
  display: block;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 8px;
  text-transform: uppercase;
}

.customer-note-textarea {
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 10px 12px;
  color: #fff;
  font-size: 13px;
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

.customer-note-textarea::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.customer-note-textarea:focus {
  outline: none;
  border-color: #e14eca;
}

.white-content .customer-note-input-label {
  color: rgba(0, 0, 0, 0.6);
}

.white-content .customer-note-textarea {
  background: #f5f6fa;
  border-color: #e3e3e3;
  color: #344675;
}

.white-content .customer-note-textarea::placeholder {
  color: #9A9A9A;
}

.white-content .customer-note-textarea:focus {
  border-color: #e14eca;
}

/* Tag picker dropdown: keep the empty/no-match hint readable and padded */
.tag-add-popper .el-select-dropdown__empty {
  padding: 10px 14px;
  font-size: 12px;
  line-height: 1.4;
  white-space: normal;
}

/* Inline tag picker sizing so it sits on the chip row baseline */
.tag-add-select .el-input__inner {
  height: 30px;
  border-radius: 12px;
  border-color: rgba(125, 125, 125, 0.4);
}

.tag-add-select .el-input__inner:focus,
.tag-add-select .el-input.is-focus .el-input__inner {
  border-color: #e14eca;
}

.custom-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #e14eca !important;
  border-color: #e14eca !important;
}

.custom-checkbox .el-checkbox__input.is-checked + .el-checkbox__label {
  color: white !important;
}

.custom-checkbox .el-checkbox__inner:hover {
  border-color: #e14eca !important;
}
</style>
